import React, { useCallback, useEffect, useState, useRef, Component } from 'react';
import { Check, ChevronLeft, ChevronRight, X, Lock } from 'lucide-react';
import { MissionNavbar } from '../components/MissionNavbar';
const WHATSAPP_URL = 'https://wa.me/77010346443?text=%D1%85%D0%BE%D1%87%D1%83%20%D0%B4%D0%B5%D0%BC%D0%BE%20Meelo';
const CHAOS = [92, 70, 45, 20, 0];
const ENERGY = [18, 40, 60, 78, 92];
const MEELO_MSGS = ['Привет. Я Meelo. Давайте победим монстров хаоса вашего детского сада.', '👾 Гримрак повержен! Данные больше не разбросаны по чатам.', '🤖 Сталеарх пал! Бюрократия больше не крадёт ваши вечера.', '💰 Златохват уничтожен! Деньги больше не утекают незаметно.', '⚔️ Все 4 монстра повержены. Ваш детский сад свободен.'];
const BUILDINGS = [{
  id: 1,
  name: 'Логово Гримрака',
  icon: '👾',
  color: '#7C4DFF',
  gradient: 'linear-gradient(135deg, #EDE7F6 0%, #D1C4E9 100%)',
  modalGradient: 'linear-gradient(135deg, #3D1A8A 0%, #1A0A3E 100%)',
  quote: 'Гримрак живёт в ваших чатах. Он не уничтожает данные — он делает их рассыпью: всё важное есть, но нигде не собрано.',
  chaos: [{
    label: '📊 Excel',
    r: -8,
    t: 12,
    l: 8
  }, {
    label: '❓ Оплаты',
    r: 5,
    t: 28,
    l: 45
  }, {
    label: '📋 Сверки',
    r: -3,
    t: 14,
    l: 68
  }]
}, {
  id: 2,
  name: 'Логово Сталеарха',
  icon: '🤖',
  color: '#E91E63',
  gradient: 'linear-gradient(135deg, #FCE4EC 0%, #F8BBD9 100%)',
  modalGradient: 'linear-gradient(135deg, #2C2C2C 0%, #1A0A0A 100%)',
  quote: 'Сталеарх — механический властитель правил. Подписи, формы, журналы — он требует всё, даже если это убивает время и силы.',
  chaos: [{
    label: '📄 Планы',
    r: 7,
    t: 10,
    l: 5
  }, {
    label: '📝 Конспекты',
    r: -5,
    t: 30,
    l: 40
  }, {
    label: '🗂 Отчёты',
    r: 4,
    t: 12,
    l: 68
  }]
}, {
  id: 3,
  name: 'Логово Златохвата',
  icon: '💰',
  color: '#F59E0B',
  gradient: 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)',
  modalGradient: 'linear-gradient(135deg, #78350F 0%, #3D1A00 100%)',
  quote: 'Златохват хватает золото — но теряет его каждый день. Ошибки граммовок, лишние закупки, ручные расчёты. Утечка не одним ударом, а капля за каплями.',
  chaos: [{
    label: '💰 Закуп',
    r: -6,
    t: 10,
    l: 6
  }, {
    label: '📝 Журнал',
    r: 5,
    t: 28,
    l: 42
  }, {
    label: '⚠️ Ошибка',
    r: -3,
    t: 12,
    l: 66
  }]
}, {
  id: 4,
  name: 'Логово Шуморяда',
  icon: '📡',
  color: '#00BCD4',
  gradient: 'linear-gradient(135deg, #E0F7FA 0%, #B2EBF2 100%)',
  modalGradient: 'linear-gradient(135deg, #006064 0%, #001F2A 100%)',
  quote: 'Шуморяд искажает сигналы. Одно сообщение — 40 уточнений. Каждый отвечает отдельно. Коммуникация превращается в шум.',
  chaos: [{
    label: '«Где меню?»',
    r: -5,
    t: 12,
    l: 4
  }, {
    label: '«Был ли ребёнок?»',
    r: 4,
    t: 30,
    l: 38
  }, {
    label: '«Что на обед?»',
    r: -2,
    t: 14,
    l: 66
  }]
}];
// ── Sound ──────────────────────────────────────────────────────────────────
function playChime() {
  try {
    const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    [523, 659, 784].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = ctx.currentTime + i * 0.14;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.12, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
      osc.start(t);
      osc.stop(t + 0.35);
    });
  } catch (_) {}
}
// ── Confetti ───────────────────────────────────────────────────────────────
const CONFETTI_COLORS = ['#7C4DFF', '#B388FF', '#EDE7F6', '#a78bfa', '#c4b5fd', '#ddd6fe'];
function Confetti({
  active
}: {
  active: boolean;
}) {
  if (!active) return null;
  return <div style={{
    position: 'fixed',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 300,
    overflow: 'hidden'
  }} data-id="element-424" data-mp="1hn7pn2m1046v">
      {Array.from({
      length: 30
    }).map((_, i) => <div key={i} style={{
      position: 'absolute',
      top: '-10px',
      left: `${i / 30 * 100 + i % 3 * 1.5}%`,
      width: i % 3 === 0 ? 8 : 6,
      height: i % 3 === 0 ? 8 : 6,
      borderRadius: i % 2 === 0 ? '50%' : '2px',
      background: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
      animation: `confetti-fall ${1.2 + i % 5 * 0.2}s ${i % 7 * 0.1}s ease-in forwards`,
      opacity: 0.9
    }} data-id="element-425" data-mp="1cnl9oletc9ud" data-mpi={i} />)}
    </div>;
}
// ── Progress Pill ──────────────────────────────────────────────────────────
function ProgressPill({
  progress
}: {
  progress: number;
}) {
  return null;
}
// ── Typing Text Component ──────────────────────────────────────────────────
function TypingText({
  lines,
  speed = 28
}: {
  lines: string[];
  speed?: number;
}) {
  const fullText = lines.join('\n');
  const [displayed, setDisplayed] = useState('');
  const [done, setDone] = useState(false);
  useEffect(() => {
    setDisplayed('');
    setDone(false);
    let i = 0;
    const iv = setInterval(() => {
      i++;
      setDisplayed(fullText.slice(0, i));
      if (i >= fullText.length) {
        clearInterval(iv);
        setDone(true);
      }
    }, speed);
    return () => clearInterval(iv);
  }, [fullText, speed]);
  return <span style={{
    whiteSpace: 'pre-line'
  }} data-id="element-426" data-mp="39366ij6d7zfr">
      {displayed}
      {!done && <span className="typing-cursor" data-id="element-427" data-mp="3d36kk2pjy8ma">|</span>}
    </span>;
}
// ── Mission 1 — Interactive Adventure ─────────────────────────────────────
const M1_CHAOS_ITEMS = [{
  sender: 'Айгерим (воспитатель)',
  text: 'Кто сегодня не пришёл?',
  time: '08:12'
}, {
  sender: 'Нурлан (завхоз)',
  text: 'Скиньте список оплат за февраль',
  time: '08:34'
}, {
  sender: 'Дина (повар)',
  text: 'От кого ещё ждём оплату?',
  time: '09:01'
}, {
  sender: 'Жанар (методист)',
  text: 'Почему у меня другая сумма в таблице?',
  time: '09:47'
}, {
  sender: 'Асель (медсестра)',
  text: 'Проверьте просрочки',
  time: '10:15'
}, {
  sender: 'Бауыржан (директор)',
  text: 'Сверьте закупки, пожалуйста',
  time: '10:52'
}];
const M1_HIGHLIGHTS = [{
  icon: '💳',
  text: 'Кто уже оплатил'
}, {
  icon: '⏳',
  text: 'От кого ещё ждём оплату'
}, {
  icon: '👥',
  text: 'Кто пришёл / не пришёл'
}, {
  icon: '📊',
  text: 'Финансы и закупки в одном месте'
}];
const M1_MEELO: (string[] | null)[] = [['Это Гримрак — монстр Хаоса.', 'Он живёт в чатах и обрывках заметок.', 'Всё важное есть — но нигде не собрано.'], null, null, null, null, null, null, null, null, null, null, null];
// Soft cloud blobs for the adventure scene
const SCENE_CLOUDS = [{
  w: 96,
  h: 56,
  top: '6%',
  left: '4%',
  anim: 'cloud-float-a',
  delay: '0s',
  opacity: 0.32
}, {
  w: 72,
  h: 44,
  top: '12%',
  right: '6%',
  anim: 'cloud-float-b',
  delay: '0.8s',
  opacity: 0.26
}, {
  w: 112,
  h: 60,
  top: '38%',
  left: '55%',
  anim: 'cloud-float-c',
  delay: '1.6s',
  opacity: 0.2
}, {
  w: 58,
  h: 36,
  top: '58%',
  left: '12%',
  anim: 'cloud-float-a',
  delay: '2.2s',
  opacity: 0.18
}];
function Mission1({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [step, setStep] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const advance = () => setStep(s => Math.min(s + 1, 12));
  const isIntro = step < 7; // steps 0-6: chat flood scene
  const showChaos = step >= 1;
  const visibleMessages = Math.min(step, M1_CHAOS_ITEMS.length);
  const showTransition = step === 7; // Meelo transition card before dashboard
  const showDashboard = step >= 8;
  const highlightCount = Math.max(0, step - 8);
  const showFinal = step >= 12;
  const currentMeelo = isIntro ? M1_MEELO[Math.min(step, 6)] : null;
  const bubbleActive = !!(currentMeelo && isIntro);
  // Dashboard highlight positions — mapped to actual dashboard cards
  const HIGHLIGHT_ZONES: {
    left: string;
    top: string;
    w: string;
    h: string;
    color: string;
  }[][] = [
  // highlight 0: "Кто уже оплатил" → карточка "Оплачено за месяц" (зелёная сумма)
  [{
    left: '5%',
    top: '60%',
    w: '19%',
    h: '16%',
    color: 'rgba(34,197,94,0.85)'
  }],
  // highlight 1: "От кого ещё ждём оплату" → карточка "Задолженность" (красная сумма)
  [{
    left: '26%',
    top: '60%',
    w: '19%',
    h: '16%',
    color: 'rgba(239,68,68,0.85)'
  }],
  // highlight 2: "Кто пришёл / не пришёл" → первый ряд карточек присутствия
  [{
    left: '4.5%',
    top: '35%',
    w: '62%',
    h: '18%',
    color: 'rgba(59,130,246,0.80)'
  }],
  // highlight 3: "Финансы и закупки" → все карточки под заголовком "за месяц"
  [{
    left: '4.6%',
    top: '59%',
    w: '82%',
    h: '35%',
    color: 'rgba(124,77,255,0.75)'
  }]];
  return <div data-id="element-428" data-mp="2qy6nitcrxwz">
      {/* ── SCENE ── */}
      <div className="relative rounded-3xl overflow-hidden mb-3 transition-all duration-700" style={{
      background: isIntro ? 'linear-gradient(180deg, #0A3D2B 0%, #128C7E 40%, #ECE5DD 100%)' : 'linear-gradient(160deg, #F0F7FF 0%, #F5EEFF 100%)',
      minHeight: isIntro ? 200 : 'auto',
      maxHeight: isIntro ? 260 : 'none'
    }} data-id="element-429" data-mp="2s9im5wycbz6">
        {/* ── INTRO SCENE LAYERS ── */}
        {isIntro && <>
            {/* Subtle WhatsApp-style background texture */}
            <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 60% 50% at 50% 30%, rgba(255,255,255,0.08) 0%, transparent 65%)'
        }} data-id="element-430" data-mp="3ph9smpwfati3" />
          </>}

        {/* WhatsApp chat flood — messages appear one per click */}
        {showChaos && isIntro && <div className="absolute inset-0 flex flex-col justify-end pb-16 px-3 gap-1.5 overflow-hidden pt-3" data-id="element-431" data-mp="czutsa6sgbjg">
            {M1_CHAOS_ITEMS.slice(0, visibleMessages).map((msg, i) => <div key={i} className="flex items-end gap-2" style={{
          animation: i === visibleMessages - 1 ? 'fadeInUp 280ms ease both' : 'none',
          alignSelf: i % 2 === 0 ? 'flex-start' : 'flex-end'
        }} data-id="element-432" data-mp="fkj0zyghfghf" data-mpi={i}>
                {i % 2 === 0 && <div className="w-6 h-6 rounded-full flex-shrink-0 flex items-center justify-center text-[9px] font-bold text-white mb-0.5" style={{
            background: `hsl(${i * 47 + 180}, 55%, 48%)`
          }} data-id="element-433" data-mp="yjoob68omi56">
                    {msg.sender.split(' ')[1]?.[0] ?? '?'}
                  </div>}
                <div className="max-w-[72%] rounded-2xl px-3 py-2 shadow-sm" style={{
            background: i % 2 === 0 ? 'rgba(255,255,255,0.93)' : 'rgba(220,248,198,0.95)',
            borderRadius: i % 2 === 0 ? '4px 16px 16px 16px' : '16px 4px 16px 16px'
          }} data-id="element-434" data-mp="1haeogn6vbquc">
                  {i % 2 === 0 && <p className="text-[9px] font-bold mb-0.5" style={{
              color: `hsl(${i * 47 + 180}, 55%, 38%)`
            }} data-id="element-435" data-mp="3nb7c6x78fmon">
                      {msg.sender}
                    </p>}
                  <p className="text-[11px] font-medium text-gray-800 leading-snug" data-id="element-436" data-mp="ev5ewfdnqlr4">
                    {msg.text}
                  </p>
                  <p className="text-[9px] text-gray-400 text-right mt-0.5 font-mono" data-id="element-437" data-mp="9xm3roc9ap3e">
                    {msg.time} ✓✓
                  </p>
                </div>
                {i % 2 !== 0 && <div className="w-6 h-6 rounded-full flex-shrink-0 flex items-center justify-center text-[9px] font-bold text-white mb-0.5" style={{
            background: `hsl(${i * 47 + 180}, 55%, 48%)`
          }} data-id="element-438" data-mp="2boz563f0meup">
                    {msg.sender.split(' ')[1]?.[0] ?? '?'}
                  </div>}
              </div>)}
          </div>}

        {/* Dashboard mockup */}
        {showDashboard && <div className="relative cursor-zoom-in" onClick={() => setLightboxOpen(true)} style={{
        animation: 'fadeInUp 500ms ease forwards'
      }} data-id="element-439" data-mp="8du9rona7ash">
            <img src="https://cdn.magicpatterns.com/uploads/7Tan4tCoZC26N1PHqU6F5U/панель_для_руководителя.png" alt="Дашборд Meelo" className="w-full h-auto block" data-id="element-440" data-mp="3vm7kufqp5lfd" />
            {/* Dashboard card highlights */}
            {HIGHLIGHT_ZONES.slice(0, highlightCount).map((zones, hi) => zones.map((z, zi) => <div key={`${hi}-${zi}`} className="absolute pointer-events-none" style={{
          left: z.left,
          top: z.top,
          width: z.w,
          height: z.h,
          border: `2.5px solid ${z.color}`,
          borderRadius: 8,
          boxShadow: `0 0 0 3px ${z.color.replace('0.7', '0.18')}, inset 0 0 12px ${z.color.replace('0.7', '0.10')}`,
          animation: 'node-pulse 1.8s ease-in-out infinite',
          animationDelay: `${zi * 0.2}s`
        }} data-id="element-441" data-mp="192nwz422olh1" data-mpi={zi} />))}
            <div className="absolute inset-0 pointer-events-none" style={{
          background: 'linear-gradient(135deg, rgba(124,77,255,0.07) 0%, transparent 55%)',
          animation: 'dashboard-glow 3s ease-in-out infinite'
        }} data-id="element-442" data-mp="bh8gyl0y7qlg" />
            <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/50 text-white text-[10px] font-medium px-2 py-1 rounded-lg backdrop-blur-sm" data-id="element-443" data-mp="2e4f3ja4oyk86">
              <span data-id="element-444" data-mp="2n4bz7vpi0jcq">🔍</span> Нажми для просмотра
            </div>
          </div>}

        {/* ── MEELO SPEECH BUBBLE — intro scene (step 0 only) ── */}
        {currentMeelo && isIntro && <div key={`bubble-${step}`} className="absolute bottom-3 left-3 right-3 flex items-end gap-2" style={{
        animation: 'fadeInUp 350ms ease forwards'
      }} data-id="element-445" data-mp="1ufo65dyicpom">
            <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 shadow-xl" style={{
          background: 'rgba(255,255,255,0.95)',
          border: '2.5px solid rgba(255,255,255,0.9)',
          animation: 'meelo-bounce 2.2s ease-in-out infinite',
          boxShadow: '0 4px 20px rgba(100,50,200,0.25)'
        }} data-id="element-446" data-mp="24apwue8flztb">
              <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-1" data-id="element-447" data-mp="18jweictp20dt" />
            </div>
            <div className="flex-1 rounded-2xl rounded-bl-lg px-3 py-2" style={{
          background: 'rgba(255,255,255,0.88)',
          backdropFilter: 'blur(16px)',
          border: '1.5px solid rgba(255,255,255,0.7)',
          boxShadow: '0 8px 32px rgba(100,50,200,0.18), 0 2px 8px rgba(0,0,0,0.06)'
        }} data-id="element-448" data-mp="1deaaagc9q9j0">
              <p className="text-xs font-semibold text-[#3D1A8A] leading-snug" data-id="element-449" data-mp="ukwniyipl9eh">
                <TypingText key={step} lines={currentMeelo} speed={26} data-id="element-450" data-mp="2azohhfvi6opw" />
              </p>
            </div>
          </div>}

        {/* Unread badge — appears as messages flood in */}
        {showChaos && isIntro && <div className="absolute top-3 right-3 flex items-center gap-1.5 rounded-full px-2.5 py-1" style={{
        background: 'rgba(239,68,68,0.92)',
        animation: 'meelo-bounce 1.8s ease-in-out infinite'
      }} data-id="element-451" data-mp="3nxyfwdowz1bm">
            <span className="text-white text-[10px] font-bold" data-id="element-452" data-mp="3jyha1j5ks25x">
              🔔 +{visibleMessages} сообщ.
            </span>
          </div>}
      </div>

      {/* Meelo bubble — outside scene (dashboard stages) */}
      {currentMeelo && !isIntro && <div className="flex items-start gap-2.5 mb-4" key={`meelo-${step}`} style={{
      animation: 'fadeInUp 400ms ease forwards'
    }} data-id="element-453" data-mp="1sbc3kyq7dmy">
          <div className="w-9 h-9 rounded-full bg-[#EDE7F6] border border-[#7C4DFF]/30 overflow-hidden flex-shrink-0 mt-0.5" style={{
        animation: 'meelo-bounce 2.4s ease-in-out infinite'
      }} data-id="element-454" data-mp="uh0c1go1pcx4">
            <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-455" data-mp="2vc6eyg0i1fw4" />
          </div>
          <div className="bg-[#F5F3FF] border border-[#DDD6FE] rounded-2xl rounded-tl-sm px-3 py-2.5 flex-1" data-id="element-456" data-mp="2glz34j4zyv4e">
            {currentMeelo.map((line, i) => <p key={i} className="text-sm text-[#5B21B6] font-medium leading-snug" data-id="element-457" data-mp="3e8ocje214a0a" data-mpi={i}>
                {line}
              </p>)}
          </div>
        </div>}

      {/* ── MEELO TRANSITION CARD (step 7) ── */}
      {showTransition && <div className="mb-4" style={{
      animation: 'fadeInUp 400ms ease forwards'
    }} data-id="element-458" data-mp="309exihpk7lxw">
          <div className="rounded-2xl p-5 mb-4" style={{
        background: 'linear-gradient(135deg, #F5F3FF 0%, #EEF4FF 100%)',
        border: '1.5px solid #DDD6FE',
        boxShadow: '0 4px 20px rgba(124,77,255,0.10)'
      }} data-id="element-459" data-mp="1ourj9o5umxbn">
            <div className="flex items-start gap-3" data-id="element-460" data-mp="dd5eirdnt9nd">
              <div className="w-10 h-10 rounded-full bg-white border border-[#7C4DFF]/20 overflow-hidden flex-shrink-0 shadow-sm" style={{
            animation: 'meelo-bounce 2.2s ease-in-out infinite'
          }} data-id="element-461" data-mp="dbm1rar7pgqc">
                <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-462" data-mp="s10b4iusfy5q" />
              </div>
              <div className="flex-1" data-id="element-463" data-mp="2xv1fiozky0m3">
                <p className="text-sm font-bold text-[#3D1A8A] mb-1 leading-snug" data-id="element-464" data-mp="2xwbdzfachat9">
                  Meelo
                </p>
                <p className="text-sm text-[#5B21B6] font-medium leading-relaxed" data-id="element-465" data-mp="32uct5p4ngpzg">
                  Гримрак силён, пока данные разбросаны. Покажу, как собрать всё
                  в одном месте — и он исчезнет.
                </p>
              </div>
            </div>
          </div>
          <button onClick={advance} className="w-full py-3 rounded-xl text-sm font-semibold bg-[#7C4DFF] text-white hover:bg-[#651FFF] transition-all active:scale-95" style={{
        boxShadow: '0 0 24px rgba(124,77,255,0.40)'
      }} data-id="element-466" data-mp="2wjzdyjopgppd">
            👀 Посмотреть
          </button>
        </div>}

      {/* Highlight items (steps 8→12) */}
      {showDashboard && <div className="flex flex-col gap-2 mb-4" data-id="element-467" data-mp="3fa77qb6im3sw">
          {M1_HIGHLIGHTS.map((item, i) => <div key={i} className="flex items-center gap-3 px-3 py-2.5 rounded-xl" style={{
        opacity: highlightCount > i ? 1 : 0,
        display: highlightCount > 0 && highlightCount > i - 1 ? 'flex' : 'none',
        transform: highlightCount > i ? 'translateY(0)' : 'translateY(8px)',
        transition: 'opacity 400ms ease, transform 400ms ease',
        background: highlightCount > i ? '#F5F3FF' : 'transparent',
        border: `1.5px solid ${highlightCount > i ? '#DDD6FE' : 'transparent'}`,
        pointerEvents: 'none'
      }} data-id="element-468" data-mp="3k8s9if1f0vjg" data-mpi={i}>
              <span className="text-base leading-none" data-id="element-469" data-mp="m0baoszj89zx">{item.icon}</span>
              <p className="text-sm font-medium text-[#1A1A2E] flex-1" data-id="element-470" data-mp="gzx299u0qy1d">
                {item.text}
              </p>
              {highlightCount > i && <Check size={14} color="#7C4DFF" strokeWidth={2.5} className="flex-shrink-0" data-id="element-471" data-mp="c0u140h5tbyo" />}
            </div>)}
        </div>}

      {/* Final message */}
      {showFinal && <div className="rounded-xl px-4 py-3 mb-5 border" style={{
      background: 'linear-gradient(135deg, #F3EEFF 0%, #EEF4FF 100%)',
      borderColor: '#DDD6FE',
      animation: 'fadeInUp 450ms ease forwards'
    }} data-id="element-472" data-mp="2y6dsdvzwrski">
          <p className="text-sm text-[#5B21B6] font-semibold leading-relaxed" data-id="element-473" data-mp="2u5bqt8iir4fd">
            ⚔️ Гримрак повержен!
          </p>
          <p className="text-xs text-[#7C4DFF] font-medium leading-relaxed mt-0.5" data-id="element-474" data-mp="2ffw3k2i75h4f">
            Данные собраны. Хаос отступил. Вы снова управляете ситуацией.
          </p>
        </div>}

      {/* ── ACTION BUTTONS ── */}
      {showFinal ? <button onClick={onComplete} className="w-full py-3 rounded-xl text-sm font-semibold bg-[#7C4DFF] text-white hover:bg-[#651FFF] transition-all shadow-lg active:scale-95" data-id="element-475" data-mp="2ai48x0q63gwj">
          Завершить миссию →
        </button> : showTransition ? null /* button is inside transition card */ : step <= 6 ? <button onClick={advance} className="w-full py-2.5 rounded-xl text-sm font-semibold transition-all active:scale-95" style={{
      background: 'rgba(255,255,255,0.82)',
      color: '#5B21B6',
      border: '1.5px solid rgba(255,255,255,0.6)',
      boxShadow: '0 2px 12px rgba(100,50,200,0.12)'
    }} data-id="element-476" data-mp="1hyifupoex85k">
          Продолжить ›
        </button> : step >= 8 && step < 12 ? <button onClick={advance} className="w-full py-2.5 rounded-xl text-sm font-medium text-[#7C4DFF] border border-[#DDD6FE] bg-[#F5F3FF] hover:bg-[#EDE7F6] transition-all active:scale-95" data-id="element-477" data-mp="1vv5jtces8ykz">
          Показать следующее ›
        </button> : null}

      {/* ── LIGHTBOX ── */}
      {lightboxOpen && <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{
      background: 'rgba(0,0,0,0.88)',
      backdropFilter: 'blur(6px)',
      animation: 'fadeInUp 200ms ease forwards'
    }} onClick={() => setLightboxOpen(false)} data-id="element-478" data-mp="2jjf2i5gp967w">
          <div className="relative w-full max-w-3xl" onClick={e => e.stopPropagation()} data-id="element-479" data-mp="mnke5g334kzk">
            <button onClick={() => setLightboxOpen(false)} className="absolute -top-10 right-0 flex items-center gap-1.5 text-white/60 hover:text-white text-sm font-medium transition-colors" data-id="element-480" data-mp="rldmofrv1r30">
              <X size={16} data-id="element-481" data-mp="3v589cri3gsc9" /> Закрыть
            </button>
            <img src="https://cdn.magicpatterns.com/uploads/7Tan4tCoZC26N1PHqU6F5U/панель_для_руководителя.png" alt="Дашборд Meelo — полный вид" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-482" data-mp="3vro9ujbbfw2" />
            <p className="text-center text-white/40 text-xs mt-3 font-medium" data-id="element-483" data-mp="1fec9kbcbt5lu">
              Панель руководителя Meelo — нажми вне изображения, чтобы закрыть
            </p>
          </div>
        </div>}
    </div>;
}
// ── Mission 2 ──────────────────────────────────────────────────────────────
const M2_SCREENSHOTS = ['https://cdn.magicpatterns.com/uploads/8BE9aBQxMzEdYJY4P1zUS9/Screenshot_2026-02-18_at_23.32.30.png', 'https://cdn.magicpatterns.com/uploads/8XVKzRYhgkqPVgs8v3V9st/Screenshot_2026-02-19_at_11.01.39.png', 'https://cdn.magicpatterns.com/uploads/qxeU4Ka2BGZ9SbhaMdQ8hh/Screenshot_2026-02-19_at_11.02.29.png'];
const M2_HIGHLIGHTS = [{
  icon: '📋',
  text: 'Циклограмма — за минуты'
}, {
  icon: '📅',
  text: 'Перспективный план — автоматически'
}, {
  icon: '📝',
  text: 'Конспекты к ООД — без ручной рутины'
}, {
  icon: '✅',
  text: 'Документы всегда готовы к проверке'
}];
const M2_EVENING_TAGS = [{
  text: 'Циклограмма...',
  top: '8%',
  left: '4%',
  anim: 'chaos-float-1'
}, {
  text: 'Конспект к ООД',
  top: '5%',
  right: '4%',
  anim: 'chaos-float-2'
}, {
  text: '⚠️ Проверка завтра!',
  top: '50%',
  right: '3%',
  anim: 'chaos-float-3'
}, {
  text: 'Старый шаблон...',
  top: '46%',
  left: '3%',
  anim: 'chaos-float-4'
}];
// ── Swipeable screenshot gallery for Mission 2 ─────────────────────────────
function M2Gallery({
  onImageClick
}: {
  onImageClick: (idx: number) => void;
}) {
  const [active, setActive] = useState(0);
  const touchStartX = useRef<number | null>(null);
  const prev = () => setActive(i => (i - 1 + M2_SCREENSHOTS.length) % M2_SCREENSHOTS.length);
  const next = () => setActive(i => (i + 1) % M2_SCREENSHOTS.length);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 38) diff > 0 ? next() : prev();
    touchStartX.current = null;
  };
  return <div className="mb-4" data-id="element-484" data-mp="3gcway7uboxn0">
      {/* Gallery container */}
      <div className="relative rounded-2xl overflow-hidden border shadow-sm cursor-pointer select-none" style={{
      borderColor: '#FCE4EC'
    }} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} onClick={() => onImageClick(active)} data-id="element-485" data-mp="3bfebd8273uro">
        {/* Browser chrome bar */}
        <div className="h-7 bg-gray-50 border-b border-gray-100 flex items-center px-3 gap-1.5 flex-shrink-0" data-id="element-486" data-mp="2wr1dg5jjs1uj">
          <div className="w-2.5 h-2.5 rounded-full bg-red-400" data-id="element-487" data-mp="2sq7qpfhuct38" />
          <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-488" data-mp="36gb55kahbii4" />
          <div className="w-2.5 h-2.5 rounded-full bg-green-400" data-id="element-489" data-mp="31pba6kkx7ai9" />
          <span className="ml-2 text-[10px] text-gray-400 font-medium" data-id="element-490" data-mp="31nrq0iw58fb7">
            {active === 0 ? 'Циклограммы и планы' : active === 1 ? 'Конспекты к ООД' : 'Документы к проверке'}
          </span>
        </div>

        {/* Images with crossfade */}
        <div className="relative" data-id="element-491" data-mp="1ogwwrs0skipa">
          {M2_SCREENSHOTS.map((src, i) => <img key={i} src={src} alt={`Методический блок — экран ${i + 1}`} className="w-full h-auto block" style={{
          position: i === 0 ? 'relative' : 'absolute',
          top: 0,
          left: 0,
          opacity: active === i ? 1 : 0,
          transition: 'opacity 260ms ease',
          pointerEvents: active === i ? 'auto' : 'none'
        }} data-id="element-492" data-mp="1sgxjs11yi27y" data-mpi={i} />)}

          {/* Prev arrow */}
          <button onClick={e => {
          e.stopPropagation();
          prev();
        }} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/90 border border-gray-200 flex items-center justify-center shadow-sm z-10 hover:bg-white transition-colors" aria-label="Предыдущий" data-id="element-493" data-mp="2g8cizkyfs3ez">
            <ChevronLeft size={16} className="text-gray-600" data-id="element-494" data-mp="jhi3hlszk64v" />
          </button>

          {/* Next arrow */}
          <button onClick={e => {
          e.stopPropagation();
          next();
        }} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/90 border border-gray-200 flex items-center justify-center shadow-sm z-10 hover:bg-white transition-colors" aria-label="Следующий" data-id="element-495" data-mp="eix57rxanwj2">
            <ChevronRight size={16} className="text-gray-600" data-id="element-496" data-mp="x8mygalesa8v" />
          </button>

          {/* Zoom hint */}
          <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/50 text-white text-[10px] font-medium px-2 py-1 rounded-lg backdrop-blur-sm pointer-events-none" data-id="element-497" data-mp="sf0ur7x83gp7">
            🔍 Нажми для просмотра
          </div>

          {/* Swipe hint — only on first view */}
          {active === 0 && <div className="absolute bottom-2 left-2 flex items-center gap-1 bg-black/40 text-white text-[10px] font-medium px-2 py-1 rounded-lg backdrop-blur-sm pointer-events-none" style={{
          animation: 'fadeInUp 600ms ease forwards'
        }} data-id="element-498" data-mp="1g4v3peef8l46">
              ← свайп →
            </div>}
        </div>
      </div>

      {/* Dot indicators */}
      <div className="flex justify-center items-center gap-2 mt-2.5" data-id="element-499" data-mp="2mwitdh9qe74e">
        {M2_SCREENSHOTS.map((_, i) => <button key={i} onClick={() => setActive(i)} aria-label={`Экран ${i + 1}`} style={{
        width: active === i ? 20 : 7,
        height: 7,
        borderRadius: 4,
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        background: active === i ? '#E91E63' : '#D1D5DB',
        transition: 'all 250ms ease'
      }} data-id="element-500" data-mp="2vv48t3jwp60y" data-mpi={i} />)}
      </div>

      {/* Screen label */}
      <p className="text-center text-[11px] text-gray-400 font-medium mt-1.5" data-id="element-501" data-mp="2188ae3i80gd">
        {active + 1} / {M2_SCREENSHOTS.length} — листай, чтобы увидеть больше
      </p>
    </div>;
}
type M2Phase = 'evening' | 'choice' | 'manual' | 'generating' | 'result';
function Mission2({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [phase, setPhase] = useState<M2Phase>('evening');
  const [manualProgress, setManualProgress] = useState(0);
  const [meeloProgress, setMeeloProgress] = useState(0);
  const [genStep, setGenStep] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIdx, setLightboxIdx] = useState(0);
  const openLightbox = (idx: number) => {
    setLightboxIdx(idx);
    setLightboxOpen(true);
  };
  // Slow manual loading
  useEffect(() => {
    if (phase !== 'manual') return;
    setManualProgress(0);
    let p = 0;
    const iv = setInterval(() => {
      p += 0.4;
      setManualProgress(Math.min(p, 26));
      if (p >= 26) clearInterval(iv);
    }, 80);
    return () => clearInterval(iv);
  }, [phase]);
  // Fast Meelo generation
  useEffect(() => {
    if (phase !== 'generating') return;
    setMeeloProgress(0);
    setGenStep(0);
    let p = 0;
    const iv = setInterval(() => {
      p += 5;
      setMeeloProgress(Math.min(p, 100));
      if (p >= 100) clearInterval(iv);
    }, 55);
    const t1 = setTimeout(() => setGenStep(1), 250);
    const t2 = setTimeout(() => setGenStep(2), 550);
    const t3 = setTimeout(() => setGenStep(3), 850);
    const t4 = setTimeout(() => setGenStep(4), 1150);
    const t5 = setTimeout(() => setPhase('result'), 1800);
    return () => {
      clearInterval(iv);
      [t1, t2, t3, t4, t5].forEach(clearTimeout);
    };
  }, [phase]);
  // ── EVENING SCENE ──
  if (phase === 'evening') {
    return <div data-id="element-502" data-mp="5jnszbqqugbh">
        {/* Problem board — structured card layout */}
        <div className="rounded-3xl overflow-hidden mb-4" style={{
        background: 'linear-gradient(160deg, #2D1B3D 0%, #1C1428 100%)'
      }} data-id="element-503" data-mp="5kyuf4wpvbzf">
          {/* Board header */}
          <div className="px-4 pt-4 pb-3 flex items-center justify-between border-b border-white/10" data-id="element-504" data-mp="2c637d05yuxr4">
            <div className="flex items-center gap-2.5" data-id="element-505" data-mp="2h4mu32sdwdkj">
              <span className="text-sm" data-id="element-506" data-mp="2l7t0cafhy4r0">🌙</span>
              <span className="text-sm font-bold text-white/80 font-mono" data-id="element-507" data-mp="2pzb1ozlfm7ci">
                19:47
              </span>
              <span className="text-xs text-white/35 font-medium" data-id="element-508" data-mp="2uyxfba569plu">Пятница</span>
            </div>
            <div className="flex items-center gap-1.5 bg-rose-500/20 border border-rose-500/30 rounded-full px-2.5 py-1" data-id="element-509" data-mp="2zwz7qlohn19z">
              <div className="w-1.5 h-1.5 rounded-full bg-rose-400" style={{
              animation: 'node-pulse 1.5s ease-in-out infinite'
            }} data-id="element-510" data-mp="34xmyd68t1g3o" />
              <span className="text-[10px] font-bold text-rose-400" data-id="element-511" data-mp="1ak56j71d9x2u">
                4 задачи не готовы
              </span>
            </div>
          </div>

          {/* Task cards */}
          <div className="p-4 space-y-2" data-id="element-512" data-mp="j8xwgvgoedw3">
            {[{
            icon: '📋',
            text: 'Циклограмма на следующую неделю',
            tag: '~2 ч',
            color: 'text-amber-400',
            bg: 'bg-amber-400/12 border-amber-400/25'
          }, {
            icon: '📝',
            text: 'Конспект к ООД — не начат',
            tag: 'срочно',
            color: 'text-rose-400',
            bg: 'bg-rose-400/12 border-rose-400/25'
          }, {
            icon: '⚠️',
            text: 'Проверка завтра утром!',
            tag: 'критично',
            color: 'text-red-400',
            bg: 'bg-red-400/15 border-red-400/30'
          }, {
            icon: '📁',
            text: 'Старый шаблон — нужно обновить',
            tag: '~1 ч',
            color: 'text-amber-400',
            bg: 'bg-amber-400/12 border-amber-400/25'
          }].map((item, i) => <div key={i} className="flex items-center gap-3 rounded-xl px-3 py-2.5 border" style={{
            background: 'rgba(255,255,255,0.05)',
            borderColor: 'rgba(255,255,255,0.10)',
            animation: `fadeInUp 350ms ${i * 80}ms ease both`
          }} data-id="element-513" data-mp="1t7pb1hzpfpgz" data-mpi={i}>
                <span className="text-base flex-shrink-0" data-id="element-514" data-mp="275nnghugtbtu">{item.icon}</span>
                <span className="text-sm font-medium text-white/75 flex-1 leading-snug" data-id="element-515" data-mp="2c5juyr2dfle5">
                  {item.text}
                </span>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${item.color} ${item.bg} flex-shrink-0`} data-id="element-516" data-mp="23652xn6k32rj">
                  {item.tag}
                </span>
              </div>)}
          </div>

          {/* Stress footer */}
          <div className="px-4 pb-4" data-id="element-517" data-mp="ronahjufdpkb">
            <div className="flex items-center gap-2 bg-white/5 rounded-xl px-3 py-2.5 border border-white/8" data-id="element-518" data-mp="2tgfcu8vtz529">
              <span className="text-lg" data-id="element-519" data-mp="2oidqnf33ypmk">😔</span>
              <p className="text-xs text-white/50 font-medium leading-snug" data-id="element-520" data-mp="2jqcio5cz3l2c">
                Это происходит каждую неделю. Каждый вечер.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-rose-50 border border-rose-100 rounded-2xl px-4 py-3 mb-4" data-id="element-521" data-mp="2apo3367xlcnc">
          <p className="text-sm text-rose-700 font-semibold leading-relaxed text-center" data-id="element-522" data-mp="2anbdc6vxlxzq">
            🤖 Это Сталеарх. Он питается вашим временем через бумажную рутину.
          </p>
        </div>
        <button onClick={() => setPhase('choice')} className="w-full py-2.5 rounded-xl text-sm font-semibold transition-all active:scale-95" style={{
        background: 'rgba(255,255,255,0.88)',
        color: '#9A3412',
        border: '1.5px solid rgba(251,146,60,0.35)',
        boxShadow: '0 2px 12px rgba(200,100,50,0.1)'
      }} data-id="element-523" data-mp="20tktxgenwdqw">
          Продолжить ›
        </button>
      </div>;
  }
  // ── CHOICE ──
  if (phase === 'choice') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-524" data-mp="1mlychsp0ltmy">
        <p className="text-xs text-gray-500 font-semibold mb-3 text-center uppercase tracking-wide" data-id="element-525" data-mp="1qnbgdx8jrmr8">
          Как победить Сталеарха?
        </p>
        <div className="grid grid-cols-2 gap-3 mb-2" data-id="element-526" data-mp="tylvdy1mie11">
          <button onClick={() => setPhase('manual')} className="rounded-2xl p-4 text-left border-2 transition-all active:scale-95 hover:border-gray-300" style={{
          background: '#F9FAFB',
          borderColor: '#E5E7EB'
        }} data-id="element-527" data-mp="yw3w515hlmxy">
            <div className="text-2xl mb-2" data-id="element-528" data-mp="2ede3dyxlu2iz">📝</div>
            <p className="text-sm font-bold text-gray-700 leading-tight mb-1.5" data-id="element-529" data-mp="2ecmc30b1iqyi">
              Составить вручную
            </p>
            <p className="text-xs text-gray-400 font-medium" data-id="element-530" data-mp="2je1rocug859i">⏱ ~3 часа</p>
          </button>
          <button onClick={() => setPhase('generating')} className="rounded-2xl p-4 text-left border-2 transition-all active:scale-95 relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, #F3EEFF 0%, #EEF4FF 100%)',
          borderColor: '#C4B5FD',
          boxShadow: '0 4px 20px rgba(124,77,255,0.18)'
        }} data-id="element-531" data-mp="1uxap6206e1r9">
            <div className="text-2xl mb-2" data-id="element-532" data-mp="28r211h1dpxq5">⚡</div>
            <p className="text-sm font-bold text-[#5B21B6] leading-tight mb-1.5" data-id="element-533" data-mp="28qa4o3zyjvyt">
              Собрать с Meelo
            </p>
            <p className="text-xs text-[#7C4DFF] font-bold" data-id="element-534" data-mp="2moqjyjbvyusk">✨ ~5 секунд</p>
            <div className="absolute top-2 right-2 bg-[#7C4DFF] text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full leading-tight" data-id="element-535" data-mp="2iqkedemsal98">
              ✓ Рекомендуем
            </div>
          </button>
        </div>
      </div>;
  }
  // ── MANUAL LOADING ──
  if (phase === 'manual') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-536" data-mp="e7tcekk3go3c">
        <div className="rounded-2xl bg-gray-50 border border-gray-200 p-5 mb-4" data-id="element-537" data-mp="i8dcnwzys7tp">
          <div className="flex items-center justify-between mb-2" data-id="element-538" data-mp="4gf53qlwijzn">
            <p className="text-sm font-semibold text-gray-600" data-id="element-539" data-mp="9gb9hqyigdfq">
              Составляю вручную...
            </p>
            <span className="text-xs font-mono text-gray-400" data-id="element-540" data-mp="3qof3bvz1aai9">
              ~3 ч осталось
            </span>
          </div>
          <div className="h-2.5 bg-gray-200 rounded-full overflow-hidden mb-4" data-id="element-541" data-mp="3vpcli8k1n4jr">
            <div className="h-full rounded-full transition-all duration-200" style={{
            width: `${manualProgress}%`,
            background: 'linear-gradient(90deg, #9CA3AF, #6B7280)'
          }} data-id="element-542" data-mp="3hp1u94etnny2" />
          </div>
          <div className="flex flex-wrap gap-1.5" data-id="element-543" data-mp="1kw9rikbo29t3">
            {['Открываю шаблон...', 'Копирую прошлый план...', 'Правлю даты...'].map((s, i) => <span key={i} className="text-[10px] text-gray-400 bg-gray-100 px-2 py-1 rounded-lg font-medium" data-id="element-544" data-mp="3lc5274wtiab0" data-mpi={i}>
                {s}
              </span>)}
          </div>
        </div>
        {manualProgress >= 18 && <>
            <div className="bg-amber-50 border border-amber-100 rounded-2xl px-4 py-3 mb-4" style={{
          animation: 'fadeInUp 300ms ease forwards'
        }} data-id="element-545" data-mp="2xlivpi2goy34">
              <p className="text-sm text-amber-700 font-semibold text-center" data-id="element-546" data-mp="2nowcexpsaf37">
                Сталеарх доволен 😅 Именно этого он и хочет — чтобы вы тратили
                часы.
              </p>
            </div>
            <button onClick={() => setPhase('generating')} className="w-full py-3 rounded-xl text-sm font-semibold bg-[#7C4DFF] text-white hover:bg-[#651FFF] transition-all active:scale-95" style={{
          animation: 'fadeInUp 400ms ease forwards',
          boxShadow: '0 0 22px rgba(124,77,255,0.38)'
        }} data-id="element-547" data-mp="2enosjko0lgsn">
              ⚡ Победить Сталеарха с Meelo →
            </button>
          </>}
      </div>;
  }
  // ── MEELO GENERATION ──
  if (phase === 'generating') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-548" data-mp="2iyk6zuuzohs3">
        <div className="rounded-2xl border p-5 mb-4" style={{
        background: 'linear-gradient(135deg, #F5F3FF 0%, #EEF4FF 100%)',
        borderColor: '#DDD6FE'
      }} data-id="element-549" data-mp="2e10twya12b1q">
          <div className="flex items-center justify-between mb-2" data-id="element-550" data-mp="2nrdbqiqgjq46">
            <p className="text-sm font-bold text-[#5B21B6]" data-id="element-551" data-mp="31paclrby2ion">
              {meeloProgress < 100 ? '⚡ Сталеарх отступает...' : '✓ Сталеарх повержен за 5 секунд!'}
            </p>
            <span className="text-xs font-mono font-bold text-[#7C4DFF]" data-id="element-552" data-mp="1ue3xxh9mx9ua">
              {Math.round(meeloProgress)}%
            </span>
          </div>
          <div className="h-2.5 bg-[#EDE7F6] rounded-full overflow-hidden mb-4" data-id="element-553" data-mp="1zab0r16qi580">
            <div className="h-full rounded-full transition-all duration-75" style={{
            width: `${meeloProgress}%`,
            background: 'linear-gradient(90deg, #7C4DFF, #B388FF)'
          }} data-id="element-554" data-mp="23cpmbt1sfj2z" />
          </div>
          <div className="flex flex-col gap-2" data-id="element-555" data-mp="2i1u2z5sxpf8z">
            {M2_HIGHLIGHTS.map((item, i) => <div key={i} className="flex items-center gap-2.5 transition-all duration-300" style={{
            opacity: genStep > i ? 1 : 0.2,
            transform: genStep > i ? 'translateX(0)' : 'translateX(-6px)'
          }} data-id="element-556" data-mp="2n31f1h2410lg" data-mpi={i}>
                <span className={`text-xs font-bold w-4 ${genStep > i ? 'text-[#7C4DFF]' : 'text-gray-300'}`} data-id="element-557" data-mp="wq2glgc7qvox">
                  {genStep > i ? '✓' : '○'}
                </span>
                <span className={`text-xs font-semibold ${genStep > i ? 'text-[#3D1A8A]' : 'text-gray-300'}`} data-id="element-558" data-mp="ke00itoohel5">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>;
  }
  // ── RESULT ──
  return <div style={{
    animation: 'fadeInUp 400ms ease forwards'
  }} data-id="element-559" data-mp="182t0r2cc28lk">
      {/* Success banner */}
      <div className="flex items-center gap-3 bg-green-50 border border-green-100 rounded-2xl px-4 py-3 mb-4" data-id="element-560" data-mp="z47fgzfh8fh3">
        <span className="text-xl" data-id="element-561" data-mp="u5np8mtuohix">✨</span>
        <div data-id="element-562" data-mp="u4mbgalg9gxi">
          <p className="text-sm font-bold text-green-700" data-id="element-563" data-mp="u78jscg600gs">
            Методический блок готов!
          </p>
          <p className="text-xs text-green-600 font-medium" data-id="element-564" data-mp="3js3htgivymtv">
            3 экрана системы — листайте, чтобы увидеть всё
          </p>
        </div>
      </div>

      {/* Swipeable gallery */}
      <M2Gallery onImageClick={openLightbox} data-id="element-565" data-mp="16kkdquqeuctf" />

      {/* Highlights */}
      <div className="flex flex-col gap-2 mb-5" data-id="element-566" data-mp="1be5f8wr7poxd">
        {M2_HIGHLIGHTS.map((item, i) => <div key={i} className="flex items-center gap-3 px-3 py-2.5 rounded-xl" style={{
        background: '#FFF0F6',
        border: '1.5px solid #FECDD3'
      }} data-id="element-567" data-mp="xna2389oklnz" data-mpi={i}>
            <span className="text-base leading-none" data-id="element-568" data-mp="1pbbvokogrbjf">{item.icon}</span>
            <p className="text-sm font-medium text-[#9D174D] flex-1" data-id="element-569" data-mp="1ubptzb09j749">
              {item.text}
            </p>
            <Check size={14} color="#E91E63" strokeWidth={2.5} className="flex-shrink-0" data-id="element-570" data-mp="1gc6z3jwgps9w" />
          </div>)}
      </div>

      <button onClick={onComplete} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all shadow-lg active:scale-95" style={{
      background: 'linear-gradient(135deg, #FF4081 0%, #E91E63 100%)',
      boxShadow: '0 4px 20px rgba(233,30,99,0.35)'
    }} data-id="element-571" data-mp="4w04kzr3islv">
        Завершить миссию →
      </button>

      {/* Lightbox */}
      {lightboxOpen && <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{
      background: 'rgba(0,0,0,0.92)',
      backdropFilter: 'blur(6px)',
      animation: 'fadeInUp 200ms ease forwards'
    }} onClick={() => setLightboxOpen(false)} data-id="element-572" data-mp="bb7ery1jwewd">
          <div className="relative w-full max-w-3xl" onClick={e => e.stopPropagation()} data-id="element-573" data-mp="3okljjd7ob5zf">
            {/* Lightbox nav */}
            <div className="flex items-center justify-between mb-3" data-id="element-574" data-mp="3jra9z4bh8b3t">
              <div className="flex gap-1.5" data-id="element-575" data-mp="2w2hlfsx6p5j8">
                {M2_SCREENSHOTS.map((_, i) => <button key={i} onClick={() => setLightboxIdx(i)} style={{
              width: i === lightboxIdx ? 20 : 7,
              height: 7,
              borderRadius: 4,
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              background: i === lightboxIdx ? '#E91E63' : 'rgba(255,255,255,0.3)',
              transition: 'all 200ms'
            }} data-id="element-576" data-mp="2r3o4fqiouweb" data-mpi={i} />)}
              </div>
              <button onClick={() => setLightboxOpen(false)} className="flex items-center gap-1.5 text-white/60 hover:text-white text-sm font-medium transition-colors" data-id="element-577" data-mp="h21xv1jqobxz">
                <X size={16} data-id="element-578" data-mp="q0dnb08vd3ou" /> Закрыть
              </button>
            </div>
            <div className="relative" data-id="element-579" data-mp="1wi0srb4cibga">
              <img src={M2_SCREENSHOTS[lightboxIdx]} alt={`Экран ${lightboxIdx + 1}`} className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-580" data-mp="21hn5ljg9hpok" />
              {/* Lightbox prev/next */}
              {lightboxIdx > 0 && <button onClick={() => setLightboxIdx(i => i - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/20 hover:bg-white/35 flex items-center justify-center transition-colors" data-id="element-581" data-mp="26ok1cwad3zsi">
                  <ChevronLeft size={18} className="text-white" data-id="element-582" data-mp="1swncr27wk80v" />
                </button>}
              {lightboxIdx < M2_SCREENSHOTS.length - 1 && <button onClick={() => setLightboxIdx(i => i + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/20 hover:bg-white/35 flex items-center justify-center transition-colors" data-id="element-583" data-mp="1iw4pryl1kbeq">
                  <ChevronRight size={18} className="text-white" data-id="element-584" data-mp="399lqpdo71qrm" />
                </button>}
            </div>
            <p className="text-center text-white/40 text-xs mt-3 font-medium" data-id="element-585" data-mp="3sj52onnam1ex">
              {lightboxIdx + 1} / {M2_SCREENSHOTS.length} — нажми вне
              изображения, чтобы закрыть
            </p>
          </div>
        </div>}
    </div>;
}
// ── Mission 3 ──────────────────────────────────────────────────────────────
const M3_WIZARD_STEPS = [{
  type: 'problem' as const
}, {
  type: 'solution' as const,
  title: 'Перспективное меню — автоматически',
  desc: 'Меню на 20 дней по СанПин — за 5 секунд, без Excel и ручного труда.',
  image: 'https://cdn.magicpatterns.com/uploads/4GEux7jgYdd8UfGkvVRV8m/menu.png',
  icon: '🍽️'
}, {
  type: 'solution' as const,
  title: 'Техкарты формируются сами',
  desc: 'Все поля, граммовки и калькуляция — система заполняет автоматически.',
  image: 'https://cdn.magicpatterns.com/uploads/a8tUBoPELZ75Eze94KtHb8/techcards.png',
  icon: '📋'
}, {
  type: 'solution' as const,
  title: 'Закуп рассчитывается по калькуляции',
  desc: 'Точный расчёт на любой период — без пересчётов вручную.',
  image: 'https://cdn.magicpatterns.com/uploads/1hHxyqRG2pwA8iigC5rVov/procurement.png',
  icon: '🛒'
}, {
  type: 'solution' as const,
  title: 'Списание без ручной рутины',
  desc: 'Расход по меню списывается за один клик — никаких таблиц.',
  image: 'https://cdn.magicpatterns.com/uploads/fcHMcXqNa442BjZtHcrVst/writeoff.png',
  icon: '✂️'
}, {
  type: 'solution' as const,
  title: 'Пищевые журналы ведутся автоматически',
  desc: 'Все 16 журналов создаются по шаблонам — готовы к проверке в любой момент.',
  image: 'https://cdn.magicpatterns.com/uploads/ceu6mmYjweyJLCT8gS4DSj/journals.jpg',
  icon: '📓'
}];
const M3_PROBLEM_NODES = [{
  label: 'Лишние закупки',
  angle: 225,
  color: '#ef4444'
}, {
  label: 'Списания без причины',
  angle: 135,
  color: '#f97316'
}, {
  label: 'Ошибки граммовок',
  angle: 315,
  color: '#ef4444'
}, {
  label: 'Разные версии меню',
  angle: 45,
  color: '#f97316'
}];
function Mission3({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const totalSteps = M3_WIZARD_STEPS.length;
  useEffect(() => {
    if (lightboxOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [lightboxOpen]);
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLightboxOpen(false);
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
  const step = M3_WIZARD_STEPS[currentStep];
  const isLast = currentStep === totalSteps - 1;
  const advance = () => {
    if (isLast) {
      onComplete();
    } else {
      setCurrentStep(s => s + 1);
    }
  };
  return <div className="flex flex-col" data-id="element-586" data-mp="kk0fzd0fp7ca">
      {/* ── PROGRESS INDICATOR ── */}
      <div className="flex items-center justify-between mb-4" data-id="element-587" data-mp="omdhfp85ej39">
        <span className="text-xs font-semibold text-gray-400 font-mono" data-id="element-588" data-mp="tdwohp0oel98">
          Шаг {currentStep + 1} из {totalSteps}
        </span>
        <div className="flex items-center gap-1.5" data-id="element-589" data-mp="yczt58cqupgo">
          {M3_WIZARD_STEPS.map((_, i) => <div key={i} style={{
          width: i === currentStep ? 20 : 7,
          height: 7,
          borderRadius: 4,
          background: i <= currentStep ? '#43A047' : '#D1D5DB',
          transition: 'all 250ms ease'
        }} data-id="element-590" data-mp="1otia3p8b0ty" data-mpi={i} />)}
        </div>
      </div>

      {/* ── STEP CONTENT ── */}
      <div key={currentStep} style={{
      animation: 'fadeInUp 280ms ease forwards',
      paddingBottom: 80
    }} data-id="element-591" data-mp="1m2alq2jxxdjq">
        {/* ── STEP 1: PROBLEM ── */}
        {step.type === 'problem' && <div className="rounded-2xl overflow-hidden" style={{
        background: 'linear-gradient(160deg, #1C1200 0%, #0F0A00 100%)',
        border: '1px solid rgba(255,200,50,0.15)'
      }} data-id="element-592" data-mp="11g4aqi9a304h">
            <div className="px-4 pt-4 pb-2 border-b border-white/10" data-id="element-593" data-mp="16cumwuhypbkm">
              <div className="flex items-center gap-3 mb-1" data-id="element-594" data-mp="ina6ojd70sf1">
                <img src="https://cdn.magicpatterns.com/uploads/rEFCDGHMZdBnp11GKMfrt5/content_5f604f69-5911-4d38-acdf-fc59ffa9447f-2.svg" alt="Златохват" style={{
              width: 36,
              height: 36,
              objectFit: 'contain',
              filter: 'drop-shadow(0 2px 8px rgba(200,140,0,0.5))'
            }} data-id="element-595" data-mp="intbcydu1kb4" />
                <div data-id="element-596" data-mp="3r3lfjjr2fxyq">
                  <h3 className="text-base font-bold text-white leading-tight" data-id="element-597" data-mp="3r44x2zct0kc8">
                    Логово Златохвата
                  </h3>
                  <p className="text-xs text-amber-400/70 font-medium mt-0.5" data-id="element-598" data-mp="26jzujwvora8k">
                    Он хватает золото — но теряет его каждый день.
                  </p>
                </div>
              </div>
            </div>

            <div className="px-4 py-4" data-id="element-599" data-mp="21m7sia1bu7qn">
              <svg viewBox="0 0 300 210" className="w-full" style={{
            overflow: 'visible'
          }} data-id="element-600" data-mp="21n9eh9jvsen5">
                <defs data-id="element-601" data-mp="2ub56i0yi9idl">
                  <radialGradient id="m3hole" cx="50%" cy="50%" r="50%" data-id="element-602" data-mp="2uade0z07g0rj">
                    <stop offset="0%" stopColor="#000" stopOpacity="1" data-id="element-603" data-mp="2gbvvrgt2jgh0" />
                    <stop offset="45%" stopColor="#1a0800" stopOpacity="1" data-id="element-604" data-mp="2kcfp09aitzxv" />
                    <stop offset="75%" stopColor="#7f1d1d" stopOpacity="0.7" data-id="element-605" data-mp="2kek3tm9ykjcx" />
                    <stop offset="100%" stopColor="#dc2626" stopOpacity="0" data-id="element-606" data-mp="14uno8mn4lk8m" />
                  </radialGradient>
                  <filter id="m3glow" x="-60%" y="-60%" width="220%" height="220%" data-id="element-607" data-mp="18vg07nndu38l">
                    <feGaussianBlur stdDeviation="4" result="blur" data-id="element-608" data-mp="1kbvtnk5ywyoh" />
                    <feMerge data-id="element-609" data-mp="1ffndq4jy51g9">
                      <feMergeNode in="blur" data-id="element-610" data-mp="1fcj4utvjdhj9" />
                      <feMergeNode in="SourceGraphic" data-id="element-611" data-mp="1agkckv737fdk" />
                    </feMerge>
                  </filter>
                </defs>

                <circle cx="150" cy="105" r="52" fill="none" stroke="#dc2626" strokeWidth="1" strokeOpacity="0.15" data-id="element-612" data-mp="282rokq5q09zy" />
                <circle cx="150" cy="105" r="42" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeOpacity="0.22" data-id="element-613" data-mp="1u4jk7x6cu6er" />
                <circle cx="150" cy="105" r="32" fill="none" stroke="#ef4444" strokeWidth="2" strokeOpacity="0.30" style={{
              animation: 'node-pulse 2s ease-in-out infinite'
            }} data-id="element-614" data-mp="iqzbohomlosh" />
                <ellipse cx="150" cy="105" rx="40" ry="11" fill="none" stroke="#dc2626" strokeWidth="3" strokeOpacity="0.28" style={{
              animation: 'sunray-rotate 5s linear infinite'
            }} data-id="element-615" data-mp="384o3gqgqpf4z" />
                <circle cx="150" cy="105" r="26" fill="url(#m3hole)" filter="url(#m3glow)" data-id="element-616" data-mp="3r1ftdiqsesi0" />
                <circle cx="150" cy="105" r="16" fill="#000" data-id="element-617" data-mp="1wog93cbgpa4e" />
                <circle cx="150" cy="105" r="9" fill="#000" data-id="element-618" data-mp="30056lvozfxdr" />
                <text x="150" y="147" textAnchor="middle" fontSize="9" fill="#ef4444" opacity="0.7" fontWeight="bold" data-id="element-619" data-mp="2v00pc3g92ymh">
                  ₸ утечка
                </text>

                {M3_PROBLEM_NODES.map((node, i) => {
              const rad = node.angle * Math.PI / 180;
              const x1 = 150 + Math.cos(rad) * 30;
              const y1 = 105 + Math.sin(rad) * 30;
              const nodeR = 88;
              const x2 = 150 + Math.cos(rad) * nodeR;
              const y2 = 105 + Math.sin(rad) * nodeR;
              const px = 150 + Math.cos(rad) * (nodeR + 4);
              const py = 105 + Math.sin(rad) * (nodeR + 4);
              const pillW = 90;
              const pillH = 20;
              return <g key={i} data-id="element-620" data-mp="k61q6iplq9s6" data-mpi={i}>
                      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={node.color} strokeWidth="1.2" strokeOpacity="0.55" strokeDasharray="4 3" style={{
                  animation: `path-flow ${1.8 + i * 0.3}s linear infinite`,
                  animationDelay: `${i * 0.4}s`
                }} data-id="element-621" data-mp="k6tnpz2rehl3" />
                      <rect x={px - pillW / 2} y={py - pillH / 2} width={pillW} height={pillH} rx="10" fill={node.color} fillOpacity="0.12" stroke={node.color} strokeOpacity="0.35" strokeWidth="1" style={{
                  animation: `fadeInUp 350ms ${i * 80}ms ease both`
                }} data-id="element-622" data-mp="3nmincms9swbe" />
                      <text x={px} y={py + 4} textAnchor="middle" fontSize="8.5" fill={node.color} opacity="0.9" fontWeight="600" data-id="element-623" data-mp="3p4qvxpdg4pk0">
                        {node.label}
                      </text>
                    </g>;
            })}
              </svg>

              <p className="text-center text-[11px] text-white/35 font-medium mt-1" data-id="element-624" data-mp="36ej0ltfzn3ed">
                Каждая ниточка — минус деньги. Златохват доволен.
              </p>
            </div>
          </div>}

        {/* ── STEPS 2–6: SOLUTION ── */}
        {step.type === 'solution' && <div data-id="element-625" data-mp="2sf011p18t0do">
            {/* Victory banner on last step */}
            {isLast && <div className="flex items-center gap-3 rounded-2xl px-4 py-3 mb-4" style={{
          background: 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)',
          border: '1.5px solid #F59E0B',
          animation: 'fadeInUp 300ms ease forwards'
        }} data-id="element-626" data-mp="17vwbiwkpamud">
                <img src="https://cdn.magicpatterns.com/uploads/rEFCDGHMZdBnp11GKMfrt5/content_5f604f69-5911-4d38-acdf-fc59ffa9447f-2.svg" alt="Златохват" style={{
            width: 32,
            height: 32,
            objectFit: 'contain',
            opacity: 0.5,
            filter: 'grayscale(0.6)'
          }} data-id="element-627" data-mp="o9845kfo6lfj" />
                <div data-id="element-628" data-mp="5hp2pi1anffm">
                  <p className="text-sm font-bold text-amber-800" data-id="element-629" data-mp="ah1yisa57wuc">
                    ⚔️ Златохват повержен!
                  </p>
                  <p className="text-xs text-amber-700 font-medium" data-id="element-630" data-mp="3eks1bottlqhv">
                    Утечки остановлены. Деньги под контролем.
                  </p>
                </div>
              </div>}

            <div className="rounded-2xl px-4 py-3.5 mb-4" style={{
          background: '#F0FDF4',
          border: '1.5px solid #BBF7D0'
        }} data-id="element-631" data-mp="3oj7udxcer9u0">
              <div className="flex items-start gap-3" data-id="element-632" data-mp="2vuttn9txpzer">
                <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-633" data-mp="30sc79diwd2t3">
                  {step.icon}
                </span>
                <div data-id="element-634" data-mp="35rf1e2xc9oma">
                  <p className="text-sm font-bold text-[#166534] leading-snug mb-1" data-id="element-635" data-mp="35qwxql8ck84c">
                    {step.title}
                  </p>
                  <p className="text-xs text-[#15803D] font-medium leading-relaxed" data-id="element-636" data-mp="3ak88uyk6zb22">
                    {step.desc}
                  </p>
                </div>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden border cursor-zoom-in shadow-sm" style={{
          borderColor: '#BBF7D0'
        }} onClick={() => setLightboxOpen(true)} data-id="element-637" data-mp="2hzrj29e57lvm">
              <div className="h-7 bg-gray-50 border-b border-gray-100 flex items-center px-3 gap-1.5 flex-shrink-0" data-id="element-638" data-mp="q506ydp2lik6">
                <div className="w-2.5 h-2.5 rounded-full bg-red-400" data-id="element-639" data-mp="l6yqm0j13xce" />
                <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-640" data-mp="g95jn59wizb2" />
                <div className="w-2.5 h-2.5 rounded-full bg-green-400" data-id="element-641" data-mp="bgvnh7i7130c" />
                <span className="ml-2 text-[10px] text-gray-400 font-medium truncate" data-id="element-642" data-mp="bfkij4d0hp7n">
                  {step.title}
                </span>
              </div>
              <img src={step.image} alt={step.title} className="w-full h-auto block" style={{
            maxHeight: 240,
            objectFit: 'cover',
            objectPosition: 'top'
          }} data-id="element-643" data-mp="2i0fbpvl9iue" />
              <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/55 text-white text-[10px] font-medium px-2 py-1 rounded-lg backdrop-blur-sm pointer-events-none" data-id="element-644" data-mp="3eyqglp7115nq">
                🔍 Нажми для просмотра
              </div>
            </div>
          </div>}
      </div>

      {/* ── STICKY BOTTOM BAR ── */}
      <div className="sticky bottom-0 left-0 right-0" style={{
      background: 'white',
      marginLeft: -24,
      marginRight: -24,
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 10,
      paddingBottom: 'max(12px, env(safe-area-inset-bottom))',
      borderTop: '1px solid #F0FDF4',
      boxShadow: '0 -4px 16px rgba(0,0,0,0.06)'
    }} data-id="element-645" data-mp="1lezq8cqunaa">
        <button onClick={advance} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all active:scale-95" style={{
        background: isLast ? 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)' : 'linear-gradient(135deg, #43A047 0%, #2E7D32 100%)',
        boxShadow: isLast ? '0 4px 16px rgba(245,158,11,0.40)' : '0 4px 16px rgba(67,160,71,0.30)'
      }} data-id="element-646" data-mp="kjrdk7elolc7">
          {isLast ? '🏆 Завершить миссию →' : 'Продолжить →'}
        </button>
      </div>

      {/* ── LIGHTBOX ── */}
      {lightboxOpen && step.type === 'solution' && <div className="fixed inset-0 z-[300] flex items-center justify-center p-4" style={{
      background: 'rgba(0,0,0,0.92)',
      backdropFilter: 'blur(6px)',
      animation: 'fadeInUp 180ms ease forwards'
    }} onClick={() => setLightboxOpen(false)} data-id="element-647" data-mp="1m3h4g4mgwzyo">
          <div className="relative w-full max-w-3xl" onClick={e => e.stopPropagation()} data-id="element-648" data-mp="3cfdkklt3yaqw">
            <button onClick={() => setLightboxOpen(false)} className="absolute -top-10 right-0 flex items-center gap-1.5 text-white/60 hover:text-white text-sm font-medium transition-colors" data-id="element-649" data-mp="37g0qbfzwq1ea">
              <X size={16} data-id="element-650" data-mp="1m0mhl1ygj4nu" /> Закрыть
            </button>
            <img src={step.image} alt={step.title} className="w-full rounded-2xl shadow-2xl" style={{
          maxHeight: '80vh',
          objectFit: 'contain'
        }} data-id="element-651" data-mp="1pzbuktfl2k6y" />
            <p className="text-center text-white/35 text-xs mt-3 font-medium" data-id="element-652" data-mp="24xdxd1esj1n5">
              {step.title} — нажми вне изображения, чтобы закрыть
            </p>
          </div>
        </div>}
    </div>;
}
// ── Mission 4 ──────────────────────────────────────────────────────────────
const M4_MSGS_WAVE1 = [{
  text: 'А был ли мой ребёнок?',
  sender: 'Мама Алины',
  top: '7%',
  left: '2%',
  anim: 'chaos-float-1'
}, {
  text: 'Что сегодня ели?',
  sender: 'Папа Димы',
  top: '5%',
  right: '2%',
  anim: 'chaos-float-2'
}, {
  text: 'Когда будут фото?',
  sender: 'Мама Саши',
  top: '50%',
  left: '1%',
  anim: 'chaos-float-3'
}, {
  text: 'Почему не ответили?',
  sender: 'Мама Лизы',
  top: '46%',
  right: '1%',
  anim: 'chaos-float-4'
}];
const M4_MSGS_WAVE2 = [{
  text: 'Есть ли меню на неделю?',
  sender: 'Папа Артёма',
  top: '24%',
  left: '3%',
  anim: 'chaos-float-2'
}, {
  text: 'Ребёнок сегодня поел?',
  sender: 'Мама Вани',
  top: '21%',
  right: '3%',
  anim: 'chaos-float-1'
}, {
  text: 'Когда следующее занятие?',
  sender: 'Мама Кати',
  top: '66%',
  left: '2%',
  anim: 'chaos-float-3'
}, {
  text: 'Можно посмотреть камеру?',
  sender: 'Папа Миши',
  top: '63%',
  right: '2%',
  anim: 'chaos-float-4'
}];
const M4_FEATURES = [{
  icon: '📸',
  text: 'Лента дня'
}, {
  icon: '🍽️',
  text: 'Меню'
}, {
  icon: '📅',
  text: 'Расписание'
}, {
  icon: '💬',
  text: 'Обращения'
}, {
  icon: '📹',
  text: 'Видеокамеры'
}];
type M4Phase = 'messages' | 'overwhelmed' | 'generating' | 'result';
// Chat bubble component
function ChatBubble({
  msg,
  delay = 0
}: {
  msg: (typeof M4_MSGS_WAVE1)[0];
  delay?: number;
}) {
  return <div className="absolute" style={{
    top: msg.top,
    left: (msg as any).left,
    right: (msg as any).right,
    maxWidth: '46%',
    animation: `${msg.anim} ${2.8}s ease-in-out infinite`,
    animationDelay: `${delay}s`
  }} data-id="element-653" data-mp="1nt0xqyv29pxk">
      <div className="rounded-2xl rounded-tl-sm px-3 py-2 shadow-sm" style={{
      background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(239,246,255,0.92) 100%)',
      border: '1px solid rgba(37,99,235,0.20)',
      backdropFilter: 'blur(8px)',
      boxShadow: '0 4px 12px rgba(37,99,235,0.10), 0 1px 3px rgba(0,0,0,0.04)'
    }} data-id="element-654" data-mp="zwwuqdjy2jv5">
        <p className="text-[9px] font-bold text-blue-500 mb-0.5 leading-none" data-id="element-655" data-mp="nmnoff2bk33l">
          {msg.sender}
        </p>
        <p className="text-[11px] font-semibold text-gray-700 leading-snug" data-id="element-656" data-mp="iodsv3con0hg">
          {msg.text}
        </p>
      </div>
    </div>;
}
function Mission4({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [phase, setPhase] = useState<M4Phase>('messages');
  const [meeloProgress, setMeeloProgress] = useState(0);
  const [genStep, setGenStep] = useState(0);
  const [resultStep, setResultStep] = useState(0);
  // Fast generation
  useEffect(() => {
    if (phase !== 'generating') return;
    setMeeloProgress(0);
    setGenStep(0);
    let p = 0;
    const iv = setInterval(() => {
      p += 5;
      setMeeloProgress(Math.min(p, 100));
      if (p >= 100) clearInterval(iv);
    }, 55);
    const timers = M4_FEATURES.map((_, i) => setTimeout(() => setGenStep(i + 1), 200 + i * 300));
    const done = setTimeout(() => setPhase('result'), 200 + M4_FEATURES.length * 300 + 500);
    return () => {
      clearInterval(iv);
      [...timers, done].forEach(clearTimeout);
    };
  }, [phase]);
  // Staggered result feature reveal
  useEffect(() => {
    if (phase !== 'result') return;
    setResultStep(0);
    const timers = M4_FEATURES.map((_, i) => setTimeout(() => setResultStep(i + 1), 200 + i * 200));
    return () => timers.forEach(clearTimeout);
  }, [phase]);
  // ── PHASE 1: MESSAGES ──
  if (phase === 'messages') {
    return <div data-id="element-657" data-mp="2d93arxqzv8m0">
        {/* Message flood board */}
        <div className="rounded-3xl overflow-hidden mb-4" style={{
        background: 'linear-gradient(160deg, #0F1E35 0%, #0A1628 100%)'
      }} data-id="element-658" data-mp="2dbz93n6r7zaz">
          {/* Board header */}
          <div className="px-4 pt-4 pb-3 flex items-center justify-between border-b border-white/10" data-id="element-659" data-mp="3to4q1pdw26ws">
            <div className="flex items-center gap-2.5" data-id="element-660" data-mp="2hl7tp5q3eog">
              <span className="text-sm" data-id="element-661" data-mp="2g0do0nblxr4">💬</span>
              <span className="text-sm font-bold text-white/80" data-id="element-662" data-mp="1n0dw73vuyta7">
                WhatsApp — Родители
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-red-500/20 border border-red-500/30 rounded-full px-2.5 py-1" data-id="element-663" data-mp="1i1b22ehf27h0">
              <div className="w-1.5 h-1.5 rounded-full bg-red-400" style={{
              animation: 'node-pulse 1.2s ease-in-out infinite'
            }} data-id="element-664" data-mp="1d7zsw6p4telx" />
              <span className="text-[10px] font-bold text-red-400" data-id="element-665" data-mp="139k1s3q3u5cf">
                +24 непрочитанных
              </span>
            </div>
          </div>

          {/* Message list */}
          <div className="p-4 space-y-2" data-id="element-666" data-mp="udb0skmhayo6">
            {[{
            sender: 'Мама Алины',
            text: 'А был ли мой ребёнок сегодня?',
            time: '08:14',
            unread: true
          }, {
            sender: 'Папа Димы',
            text: 'Что сегодня ели на обед?',
            time: '09:02',
            unread: true
          }, {
            sender: 'Мама Саши',
            text: 'Когда будут фотографии?',
            time: '10:31',
            unread: true
          }, {
            sender: 'Мама Лизы',
            text: 'Почему не отвечаете на сообщения?',
            time: '11:47',
            unread: true
          }].map((msg, i) => <div key={i} className="flex items-start gap-3 rounded-xl px-3 py-2.5 border" style={{
            background: 'rgba(255,255,255,0.05)',
            borderColor: 'rgba(255,255,255,0.10)',
            animation: `fadeInUp 350ms ${i * 80}ms ease both`
          }} data-id="element-667" data-mp="2m2d2xoy6l6z9" data-mpi={i}>
                <div className="w-7 h-7 rounded-full bg-blue-500/30 border border-blue-400/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-668" data-mp="fdqd9xjrrblp">
                  <span className="text-[10px] font-bold text-blue-300" data-id="element-669" data-mp="itbcd0c9e0lt">
                    {msg.sender.split(' ')[1]?.[0] ?? '?'}
                  </span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-670" data-mp="8vn4r9tk0ym8">
                  <div className="flex items-center justify-between gap-2 mb-0.5" data-id="element-671" data-mp="8wyavgah2igi">
                    <span className="text-[11px] font-bold text-white/70" data-id="element-672" data-mp="dvjdfmd75e84">
                      {msg.sender}
                    </span>
                    <span className="text-[10px] text-white/30 font-mono flex-shrink-0" data-id="element-673" data-mp="11m5h71g64ccb">
                      {msg.time}
                    </span>
                  </div>
                  <p className="text-xs text-white/55 leading-snug truncate" data-id="element-674" data-mp="rtq169oflxu2">
                    {msg.text}
                  </p>
                </div>
                {msg.unread && <div className="w-2 h-2 rounded-full bg-blue-400 flex-shrink-0 mt-1.5" data-id="element-675" data-mp="1khvjkps0jaqq" />}
              </div>)}
          </div>

          {/* Footer */}
          <div className="px-4 pb-4" data-id="element-676" data-mp="1z5vo0urg51pt">
            <div className="flex items-center gap-2 bg-white/5 rounded-xl px-3 py-2.5 border border-white/8" data-id="element-677" data-mp="1z4uc6o2lwb71">
              <span className="text-lg" data-id="element-678" data-mp="1u4g1ey9men5b">😓</span>
              <p className="text-xs text-white/50 font-medium leading-snug" data-id="element-679" data-mp="1q45y5td7qau5">
                Одни и те же вопросы. Каждый день. Снова и снова.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-100 rounded-2xl px-4 py-3 mb-4" data-id="element-680" data-mp="1g7t4gvho3wze">
          <p className="text-sm text-blue-800 font-semibold leading-relaxed text-center" data-id="element-681" data-mp="1bfsyalb087ud">
            📡 Это Шуморяд — монстр Сбоя коммуникаций. Он превращает каждый
            вопрос в 40 уточнений.
          </p>
        </div>

        <button onClick={() => setPhase('overwhelmed')} className="w-full py-3 rounded-xl text-sm font-semibold transition-all active:scale-95" style={{
        background: '#F9FAFB',
        color: '#374151',
        border: '1.5px solid #E5E7EB'
      }} data-id="element-682" data-mp="12gxs397ymxr2">
          💬 Ответить вручную
        </button>
      </div>;
  }
  // ── PHASE 2: OVERWHELMED ──
  if (phase === 'overwhelmed') {
    return <div style={{
      animation: 'fadeInUp 300ms ease forwards'
    }} data-id="element-683" data-mp="3e26on3dezud7">
        <div className="relative rounded-3xl overflow-hidden mb-4" style={{
        background: 'linear-gradient(180deg, #FFF3E0 0%, #FFE0B2 100%)',
        minHeight: 220
      }} data-id="element-684" data-mp="3i4tl5hl163gq">
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 65% 55% at 50% 35%, rgba(255,160,50,0.18) 0%, transparent 65%)'
        }} data-id="element-685" data-mp="2qe6vjwsmrrvg" />

          {/* All 8 messages */}
          {[...M4_MSGS_WAVE1, ...M4_MSGS_WAVE2].map((msg, i) => <ChatBubble key={i} msg={msg} delay={i * 0.3} data-id="element-686" data-mp="26p4uaf4nokan" data-mpi={i} />)}

          {/* Exploding notification */}
          <div className="absolute top-3 right-3 flex items-center gap-1.5 rounded-full px-2.5 py-1" style={{
          background: 'rgba(239,68,68,0.95)',
          boxShadow: '0 0 12px rgba(239,68,68,0.5)',
          animation: 'meelo-bounce 1.2s ease-in-out infinite'
        }} data-id="element-687" data-mp="1nk02qxp99ex4">
            <span className="text-white text-[10px] font-bold" data-id="element-688" data-mp="1si1m7jqlfg94">
              🔔 +47 сообщений!
            </span>
          </div>

          {/* Overwhelmed teacher */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-1" style={{
          marginTop: -10
        }} data-id="element-689" data-mp="21cpqp7ocgtwv">
            <div className="text-4xl" style={{
            animation: 'meelo-bounce 1.2s ease-in-out infinite'
          }} data-id="element-690" data-mp="2bb5i7braa56w">
              😱
            </div>
            <div className="text-2xl opacity-70" data-id="element-691" data-mp="gxebol4941fo">📱</div>
          </div>

          {/* Meelo speech bubble */}
          <div className="absolute bottom-4 left-4 right-4 flex items-end gap-3" style={{
          animation: 'fadeInUp 400ms ease forwards'
        }} data-id="element-692" data-mp="2sjyb8cvbu1rv">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 shadow-lg" style={{
            background: 'rgba(255,255,255,0.95)',
            border: '2px solid rgba(255,255,255,0.9)',
            animation: 'meelo-bounce 2.2s ease-in-out infinite'
          }} data-id="element-693" data-mp="2it3o76a9ay5d">
              <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-1" data-id="element-694" data-mp="1zur62v1dadxn" />
            </div>
            <div className="flex-1 rounded-3xl rounded-bl-lg px-4 py-3" style={{
            background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(16px)',
            border: '1.5px solid rgba(255,255,255,0.75)',
            boxShadow: '0 8px 28px rgba(255,140,0,0.12)'
          }} data-id="element-695" data-mp="3u9bjqnr9t97j">
              <p className="text-sm font-semibold text-[#1E3A5F] leading-relaxed" data-id="element-696" data-mp="3ns09xjpy9a2k">
                Шуморяд питается этим хаосом.{' '}
                <span className="text-cyan-600 font-bold" data-id="element-697" data-mp="3iv02p5hd619v">
                  Пора его уничтожить — дадим родителям ответы сами.
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 border border-orange-100 rounded-2xl px-4 py-3 mb-4" data-id="element-698" data-mp="fdi5drz7wcnp">
          <p className="text-sm text-orange-800 font-semibold leading-relaxed text-center" data-id="element-699" data-mp="ak6yxrybhxwb">
            Шуморяд доволен — пока вы тонете в сообщениях. Время нанести удар.
          </p>
        </div>

        <button onClick={() => setPhase('generating')} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all active:scale-95" style={{
        background: 'linear-gradient(135deg, #006064 0%, #00838F 100%)',
        boxShadow: '0 0 22px rgba(0,188,212,0.40)'
      }} data-id="element-700" data-mp="133lzn8qin021">
          ⚔️ Уничтожить Шуморяда
        </button>
      </div>;
  }
  // ── PHASE 3: GENERATING ──
  if (phase === 'generating') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-701" data-mp="1klkpqrf6md5r">
        <div className="rounded-2xl border p-5 mb-4" style={{
        background: 'linear-gradient(135deg, #EFF6FF 0%, #EEF2FF 100%)',
        borderColor: '#BFDBFE'
      }} data-id="element-702" data-mp="1piuee4uqyksj">
          <div className="flex items-center justify-between mb-2" data-id="element-703" data-mp="1ydqwjmwg37sj">
            <p className="text-sm font-bold text-[#1E40AF]" data-id="element-704" data-mp="2396bki66v9qj">
              {meeloProgress < 100 ? '🚀 Открываем портал...' : '✓ Портал готов!'}
            </p>
            <span className="text-xs font-mono font-bold text-blue-600" data-id="element-705" data-mp="2d9gm1v0ua320">
              {Math.round(meeloProgress)}%
            </span>
          </div>
          <div className="h-2.5 bg-blue-100 rounded-full overflow-hidden mb-4" data-id="element-706" data-mp="2tkj2txia5c4t">
            <div className="h-full rounded-full transition-all duration-75" style={{
            width: `${meeloProgress}%`,
            background: 'linear-gradient(90deg, #2979FF, #82B1FF)'
          }} data-id="element-707" data-mp="2tmn22258hmyr" />
          </div>
          <div className="flex flex-col gap-2" data-id="element-708" data-mp="2ew62koc5t74i">
            {M4_FEATURES.map((item, i) => <div key={i} className="flex items-center gap-2.5 transition-all duration-300" style={{
            opacity: genStep > i ? 1 : 0.2,
            transform: genStep > i ? 'translateX(0)' : 'translateX(-6px)'
          }} data-id="element-709" data-mp="2avccbob8vg8g" data-mpi={i}>
                <span className={`text-xs font-bold w-4 ${genStep > i ? 'text-blue-600' : 'text-gray-300'}`} data-id="element-710" data-mp="1w3bzosrt95gn">
                  {genStep > i ? '✓' : '○'}
                </span>
                <span className="text-base leading-none" data-id="element-711" data-mp="6lwxzixi45by">{item.icon}</span>
                <span className={`text-xs font-semibold ${genStep > i ? 'text-[#1E40AF]' : 'text-gray-300'}`} data-id="element-712" data-mp="bgaszk894ag3">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>;
  }
  // ── PHASE 4: RESULT ──
  return <div style={{
    animation: 'fadeInUp 400ms ease forwards'
  }} data-id="element-713" data-mp="q9w60m0okydo">
      {/* Success banner */}
      <div className="flex items-center gap-3 bg-blue-50 border border-blue-100 rounded-2xl px-4 py-3 mb-4" data-id="element-714" data-mp="gdt7dq51fhvh">
        <img src="https://cdn.magicpatterns.com/uploads/wQPWQKaDmAhtMozvA5NNHi/content_19e2a54f-5361-46b5-b702-555ecd730fd5-2.svg" alt="Шуморяд" style={{
        width: 32,
        height: 32,
        objectFit: 'contain',
        opacity: 0.45,
        filter: 'grayscale(0.7)'
      }} data-id="element-715" data-mp="lcno8mjg2wcy" />
        <div data-id="element-716" data-mp="iijkk81r9vyw">
          <p className="text-sm font-bold text-blue-800" data-id="element-717" data-mp="im7e3777aidm">
            ⚔️ Шуморяд повержен! Сигнал восстановлен.
          </p>
          <p className="text-xs text-blue-600 font-medium" data-id="element-718" data-mp="9jpoqjw919me">
            Родители сами находят ответы — без лишних сообщений
          </p>
        </div>
      </div>

      {/* Phone mockups */}
      <div className="rounded-3xl mb-4 flex items-center justify-center relative overflow-hidden" style={{
      background: 'linear-gradient(135deg, #E3F2FD 0%, #E8EAF6 100%)',
      minHeight: 200,
      padding: '16px 0 8px'
    }} data-id="element-719" data-mp="11am1zlm81ga7">
        {/* Soft glow */}
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(41,121,255,0.10) 0%, transparent 70%)'
      }} data-id="element-720" data-mp="wjvwm8dspdfi" />

        <div className="relative flex items-end justify-center" style={{
        height: 180,
        width: '100%'
      }} data-id="element-721" data-mp="1p0zxjm40lx9j">
          {/* Back phone */}
          <img src="https://cdn.magicpatterns.com/uploads/72Lf8Yrm1xA7wzLU6cnKZw/Mockuuups_Free_Transparent_iPhone_Air_Mockup.png" alt="Родительское приложение" style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-108%) rotate(-6deg)',
          height: 148,
          opacity: 0.78,
          filter: 'drop-shadow(0 6px 16px rgba(0,0,0,0.12))'
        }} data-id="element-722" data-mp="34qr2cfj00o5d" />
          {/* Front phone */}
          <img src="https://cdn.magicpatterns.com/uploads/m64wkFNvbCAXCjaTobC78V/Mockuuups_Free_Transparent_iPhone_Air_Mockup.png" alt="Лента дня" style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-28%)',
          height: 168,
          filter: 'drop-shadow(0 10px 28px rgba(41,121,255,0.22))',
          zIndex: 2
        }} data-id="element-723" data-mp="30nufudqc87w5" />
        </div>
      </div>

      {/* Feature pills — staggered reveal */}
      <div className="flex flex-wrap gap-2 mb-5 justify-center" data-id="element-724" data-mp="s1ps89q7ygaw">
        {M4_FEATURES.map((item, i) => <div key={i} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-400" style={{
        opacity: resultStep > i ? 1 : 0,
        transform: resultStep > i ? 'translateY(0) scale(1)' : 'translateY(6px) scale(0.95)',
        background: '#EFF6FF',
        border: '1.5px solid #BFDBFE',
        color: '#1E40AF',
        transitionDelay: `${i * 80}ms`
      }} data-id="element-725" data-mp="x012glkfestn" data-mpi={i}>
            <span data-id="element-726" data-mp="3hr1koxanxkcx">{item.icon}</span>
            <span data-id="element-727" data-mp="3hq9qnqwpruor">{item.text}</span>
            <Check size={11} color="#2979FF" strokeWidth={3} data-id="element-728" data-mp="3hp6vv7w9t83k" />
          </div>)}
      </div>

      <button onClick={onComplete} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all shadow-lg active:scale-95" style={{
      background: 'linear-gradient(135deg, #2979FF 0%, #1565C0 100%)',
      boxShadow: '0 4px 20px rgba(41,121,255,0.38)'
    }} data-id="element-729" data-mp="1yu2pga6ymwqz">
        Завершить миссию →
      </button>
    </div>;
}
// ── Building SVG Illustrations ─────────────────────────────────────────────
function GrimrakSVG() {
  return <div style={{
    width: '100%',
    height: '100%',
    position: 'relative'
  }} data-id="element-730" data-mp="1b4hvyxd6kh3g">
      <img src="https://cdn.magicpatterns.com/uploads/oBvAZtqzPuy7HXhDyjVwCK/монстр_1.svg" alt="Гримрак" style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }} data-id="element-731" data-mp="125wi3finlq90" />
    </div>;
}
function StalearchSVG() {
  return <div style={{
    width: '100%',
    height: '100%',
    position: 'relative'
  }} data-id="element-732" data-mp="sa2wz7qvcofm">
      <img src="https://cdn.magicpatterns.com/uploads/jZiruc2coCdxTuUVHLfsi2/content_60a30ee9-16df-41f1-9c0f-90f90e440018-2.svg" alt="Сталеарх" style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }} data-id="element-733" data-mp="2x8t4gg6w8hob" />
    </div>;
}
function ZlatohvatSVG() {
  return <div style={{
    width: '100%',
    height: '100%',
    position: 'relative'
  }} data-id="element-734" data-mp="29igmsdluj6kj">
      <img src="https://cdn.magicpatterns.com/uploads/rEFCDGHMZdBnp11GKMfrt5/content_5f604f69-5911-4d38-acdf-fc59ffa9447f-2.svg" alt="Златохват" style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }} data-id="element-735" data-mp="2ek605zwjjwbs" />
    </div>;
}
function ShumoryadSVG() {
  return <div style={{
    width: '100%',
    height: '100%',
    position: 'relative'
  }} data-id="element-736" data-mp="3txike0yyn07n">
      <img src="https://cdn.magicpatterns.com/uploads/wQPWQKaDmAhtMozvA5NNHi/content_19e2a54f-5361-46b5-b702-555ecd730fd5-2.svg" alt="Шуморяд" style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }} data-id="element-737" data-mp="1natciezhhthk" />
    </div>;
}
function FoodCastleSVG() {
  return <svg viewBox="0 0 80 92" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-738" data-mp="1s94lknhyfzyq">
      {/* Shadow */}
      <ellipse cx="40" cy="88" rx="30" ry="5" fill="rgba(0,0,0,0.12)" data-id="element-739" data-mp="260j4yvfry36b" />
      {/* Round tower body */}
      <ellipse cx="40" cy="62" rx="34" ry="28" fill="#388E3C" data-id="element-740" data-mp="21z7e6ml5zbwj" />
      {/* Roof cone */}
      <polygon points="40,20 70,50 10,50" fill="#2E7D32" data-id="element-741" data-mp="2fyp8fhh8bhda" />
      {/* Roof highlight */}
      <polygon points="40,20 55,38 40,44" fill="#43A047" opacity="0.5" data-id="element-742" data-mp="2b0dyz7uuj8vl" />
      {/* Apple on top */}
      <circle cx="40" cy="18" r="7" fill="#E53935" data-id="element-743" data-mp="lkxqluoqxr6r" />
      <path d="M40 11 Q45 6 48 9" stroke="#2E7D32" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-744" data-mp="lntppmcbylws" />
      <ellipse cx="37" cy="16" rx="2" ry="3" fill="rgba(255,255,255,0.3)" transform="rotate(-20 37 16)" data-id="element-745" data-mp="2gpnp2q6dbv1g" />
      {/* Windows */}
      <circle cx="28" cy="58" r="7" fill="#E8F5E9" opacity="0.8" data-id="element-746" data-mp="2ppu0m6iiakxz" />
      <circle cx="52" cy="58" r="7" fill="#E8F5E9" opacity="0.8" data-id="element-747" data-mp="2prokrilye910" />
      {/* Door */}
      <rect x="32" y="68" width="16" height="20" rx="8" fill="rgba(0,0,0,0.22)" data-id="element-748" data-mp="2upyfjs3rn7m3" />
      {/* Side bushes */}
      <ellipse cx="10" cy="72" rx="9" ry="6" fill="#66BB6A" opacity="0.7" transform="rotate(-15 10 72)" data-id="element-749" data-mp="34m1fqsf24w6e" />
      <ellipse cx="70" cy="72" rx="9" ry="6" fill="#66BB6A" opacity="0.7" transform="rotate(15 70 72)" data-id="element-750" data-mp="3df50lls18bb2" />
    </svg>;
}
function BastionSVG() {
  return <svg viewBox="0 0 80 92" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-751" data-mp="3ncswwg5adqvc">
      {/* Shadow */}
      <ellipse cx="40" cy="88" rx="28" ry="5" fill="rgba(0,0,0,0.12)" data-id="element-752" data-mp="1ceiqt0qvv5y" />
      {/* Main tower */}
      <rect x="20" y="28" width="40" height="58" rx="6" fill="#1565C0" data-id="element-753" data-mp="3shmzx16untqv" />
      {/* Roof */}
      <polygon points="40,4 66,28 14,28" fill="#0D47A1" data-id="element-754" data-mp="3nitiwysctkly" />
      {/* Roof highlight */}
      <polygon points="40,4 55,18 40,24" fill="#1976D2" opacity="0.5" data-id="element-755" data-mp="3jhhs4pxqutc6" />
      {/* Battlements */}
      <rect x="19" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-756" data-mp="k2d1c32656nu" />
      <rect x="27" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-757" data-mp="k1l4kowu52vz" />
      <rect x="35" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-758" data-mp="f4b8wriuruzp" />
      <rect x="43" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-759" data-mp="acbe1dhn3s9z" />
      <rect x="51" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-760" data-mp="aagt3z6dc05w" />
      {/* Windows */}
      <rect x="26" y="36" width="12" height="10" rx="5" fill="#E3F2FD" opacity="0.85" data-id="element-761" data-mp="68vjcmp4s1zx" />
      <rect x="42" y="36" width="12" height="10" rx="5" fill="#E3F2FD" opacity="0.85" data-id="element-762" data-mp="y1vvfry5ahh5" />
      <rect x="26" y="52" width="12" height="10" rx="5" fill="#E3F2FD" opacity="0.7" data-id="element-763" data-mp="1ho3b9ft9awfp" />
      <rect x="42" y="52" width="12" height="10" rx="5" fill="#E3F2FD" opacity="0.7" data-id="element-764" data-mp="17sru6qudld4s" />
      {/* Door */}
      <rect x="30" y="68" width="20" height="18" rx="10" fill="rgba(0,0,0,0.25)" data-id="element-765" data-mp="20gnxwfid45b2" />
      {/* Speech bubble icon */}
      <rect x="48" y="10" width="22" height="14" rx="5" fill="white" opacity="0.9" data-id="element-766" data-mp="25ez84rckkhtt" />
      <polygon points="52,24 48,30 58,24" fill="white" opacity="0.9" data-id="element-767" data-mp="1vh1l276g4r2s" />
      <circle cx="55" cy="17" r="1.5" fill="#1565C0" data-id="element-768" data-mp="1vje3elg493gd" />
      <circle cx="59" cy="17" r="1.5" fill="#1565C0" data-id="element-769" data-mp="f2jjfk265v08" />
      <circle cx="63" cy="17" r="1.5" fill="#1565C0" data-id="element-770" data-mp="k2eb3ptrqomc" />
    </svg>;
}
const BUILDING_SVGS = [GrimrakSVG, StalearchSVG, ZlatohvatSVG, ShumoryadSVG, FoodCastleSVG, BastionSVG];
// ── Adventure Map Section ──────────────────────────────────────────────────
function AdventureMap({
  completedCount,
  openMission,
  allDone
}: {
  completedCount: number;
  openMission: (id: number) => void;
  allDone: boolean;
}) {
  const buildingPositions = [{
    cx: 130,
    cy: 90
  }, {
    cx: 390,
    cy: 230
  }, {
    cx: 130,
    cy: 400
  }, {
    cx: 390,
    cy: 570
  }];
  const PATH = 'M 130,90 C 260,90 260,230 390,230 C 520,230 520,400 130,400 C 0,400 0,570 390,570';
  const TOTAL_LEN = 840;
  const progressLen = Math.min(completedCount, 3) * (TOTAL_LEN / 3);
  return <section id="map-section" className="py-16 lg:py-20 relative overflow-hidden" style={{
    background: '#F6F1E8'
  }} data-id="element-771" data-mp="2jk7wucv0e1td">
      {/* Parchment texture overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.055'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'repeat'
    }} data-id="element-772" data-mp="1rt1tzonwlq0e" />
      {/* Vignette */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 85% 85% at 50% 50%, transparent 55%, rgba(160,120,60,0.22) 100%)'
    }} data-id="element-773" data-mp="17t4978l1lir8" />
      {/* Decorative border frame */}
      <div className="absolute inset-4 sm:inset-8 pointer-events-none rounded-2xl" style={{
      border: '2px solid rgba(139,105,20,0.22)',
      boxShadow: 'inset 0 0 50px rgba(139,105,20,0.07)'
    }} data-id="element-774" data-mp="tuw7knd29t9q" />
      {/* Corner ornaments */}
      {[{
      top: 12,
      left: 12
    }, {
      top: 12,
      right: 12
    }, {
      bottom: 12,
      left: 12
    }, {
      bottom: 12,
      right: 12
    }].map((pos, i) => <div key={i} className="absolute text-[#8B6914] text-xl pointer-events-none select-none" style={{
      ...pos,
      opacity: 0.35
    }} data-id="element-775" data-mp="3j6m6tn16ohtx" data-mpi={i}>
          ✦
        </div>)}

      {/* ── MAP COMPLETION BRIGHTENING ── */}
      {allDone && <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 80% 70% at 50% 45%, rgba(255,220,100,0.22) 0%, transparent 70%)',
      animation: 'map-brighten 1200ms ease forwards'
    }} data-id="element-776" data-mp="10ptsy0iva9s" />}

      <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-777" data-mp="27sqpc7mt3wzj">
        {/* ── HEADLINE ── */}
        <div className="text-center mb-10" data-id="element-778" data-mp="1zq7zom3m2qx8">
          <div className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase mb-3 px-4 py-1.5 rounded-full" style={{
          color: '#8B6914',
          background: 'rgba(139,105,20,0.10)',
          border: '1px solid rgba(139,105,20,0.20)'
        }} data-id="element-779" data-mp="1zt3wg73q39k3">
            🗺️ Карта миссий
          </div>
          <h2 className="text-2xl md:text-3xl font-bold leading-tight" style={{
          color: '#3D2800'
        }} data-id="element-780" data-mp="2iokhsxci3b4y">
            Логова четырёх монстров
          </h2>
          <p className="text-sm mt-2 font-medium" style={{
          color: '#8B6914'
        }} data-id="element-781" data-mp="2sex2cpkbf4b3">
            4 монстра — 4 победы на пути к порядку
          </p>
        </div>

        {/* ── DESKTOP MAP ── */}
        <div className="hidden sm:block relative mx-auto" style={{
        maxWidth: 520,
        height: 680
      }} data-id="element-782" data-mp="2xfba06i08c8l">
          {/* ── MAP SVG CANVAS ── */}
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 520 680" preserveAspectRatio="xMidYMid meet" style={{
          overflow: 'visible'
        }} data-id="element-783" data-mp="3l2ewrd8s6el4">
            <defs data-id="element-784" data-mp="3bzxcv5glly1a">
              <filter id="map-glow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-785" data-mp="3c3bdo99m5z6m">
                <feGaussianBlur stdDeviation="4" result="blur" data-id="element-786" data-mp="324vo4aq8ixz8" />
                <feMerge data-id="element-787" data-mp="2ocp6ek7foixo">
                  <feMergeNode in="blur" data-id="element-788" data-mp="2odh1ltx4cenf" />
                  <feMergeNode in="SourceGraphic" data-id="element-789" data-mp="2sdhh7hvyevw2" />
                </feMerge>
              </filter>
              <filter id="fog-blur" x="-20%" y="-20%" width="140%" height="140%" data-id="element-790" data-mp="2edq4dkh6bljn">
                <feGaussianBlur stdDeviation="3" data-id="element-791" data-mp="2jevy9lmkleur" />
              </filter>
            </defs>

            {/* ── GROUND PATCHES ── */}
            <ellipse cx="130" cy="118" rx="72" ry="24" fill="#E8D9B8" opacity="0.6" data-id="element-792" data-mp="3ho3zo8gwd940" />
            <ellipse cx="390" cy="258" rx="72" ry="24" fill="#E8D9B8" opacity="0.55" data-id="element-793" data-mp="37yu8qvxshwhh" />
            <ellipse cx="130" cy="428" rx="72" ry="24" fill="#E8D9B8" opacity="0.6" data-id="element-794" data-mp="32xmzstjwur98" />
            <ellipse cx="390" cy="598" rx="72" ry="24" fill="#E8D9B8" opacity="0.55" data-id="element-795" data-mp="2tzbcb0ecc9l0" />

            {/* ── DECORATIVE HILLS ── */}
            <ellipse cx="30" cy="340" rx="55" ry="28" fill="#C8B88A" opacity="0.35" data-id="element-796" data-mp="s5bz29hnri5o" />
            <ellipse cx="490" cy="160" rx="48" ry="22" fill="#C8B88A" opacity="0.30" data-id="element-797" data-mp="uq0ayb2arb9z" />
            <ellipse cx="460" cy="480" rx="52" ry="24" fill="#C8B88A" opacity="0.32" data-id="element-798" data-mp="14ifrd3xy3rsr" />

            {/* ── SMALL LAKE / POND ── */}
            <ellipse cx="430" cy="450" rx="42" ry="20" fill="#A8C8E0" opacity="0.55" data-id="element-799" data-mp="bvlbylfzjim5" />
            <ellipse cx="430" cy="450" rx="36" ry="15" fill="#B8D8F0" opacity="0.45" data-id="element-800" data-mp="lq4x1yhcx269" />
            <ellipse cx="424" cy="445" rx="10" ry="4" fill="white" opacity="0.28" transform="rotate(-25 424 445)" data-id="element-801" data-mp="1x61u69zcmsek" />
            <text x="430" y="454" textAnchor="middle" fontSize="10" opacity="0.5" data-id="element-802" data-mp="25j7xwknc3do">
              🦆
            </text>

            {/* ── TREES ── */}
            {/* Tree cluster top-left */}
            <g opacity="0.72" data-id="element-803" data-mp="65jobmrb2ond">
              <ellipse cx="42" cy="162" rx="10" ry="3" fill="rgba(0,0,0,0.10)" data-id="element-804" data-mp="3ektmijs2r9pv" />
              <rect x="39" y="148" width="5" height="16" fill="#8B6914" opacity="0.8" data-id="element-805" data-mp="3al300s9kzfr5" />
              <polygon points="42,128 56,148 28,148" fill="#5D8A3C" data-id="element-806" data-mp="3jilqwd9wooay" />
              <polygon points="42,120 54,138 30,138" fill="#6B9E47" data-id="element-807" data-mp="2vtan0mx9edsl" />
            </g>
            {/* Tree right side */}
            <g opacity="0.65" data-id="element-808" data-mp="2qupsn44ouoc2">
              <ellipse cx="478" cy="310" rx="10" ry="3" fill="rgba(0,0,0,0.10)" data-id="element-809" data-mp="16d8by0b4d1mp" />
              <rect x="475" y="296" width="5" height="16" fill="#8B6914" opacity="0.8" data-id="element-810" data-mp="1b588rjvw7ef2" />
              <polygon points="478,276 492,296 464,296" fill="#5D8A3C" data-id="element-811" data-mp="12bv7nunod6hw" />
              <polygon points="478,268 490,286 466,286" fill="#6B9E47" data-id="element-812" data-mp="1q2irneav7mkt" />
            </g>
            {/* Small bush bottom-left */}
            <g opacity="0.60" data-id="element-813" data-mp="1u0osk5p0v7xt">
              <ellipse cx="55" cy="518" rx="22" ry="12" fill="#6B9E47" data-id="element-814" data-mp="1g39xolg027yg" />
              <ellipse cx="44" cy="514" rx="14" ry="10" fill="#7BAF52" data-id="element-815" data-mp="1g5e1l3dwf6yq" />
              <ellipse cx="66" cy="514" rx="14" ry="10" fill="#7BAF52" data-id="element-816" data-mp="1l0jn413e2jma" />
            </g>
            {/* Small bush top-right */}
            <g opacity="0.55" data-id="element-817" data-mp="4q7hvslq5mfc">
              <ellipse cx="468" cy="148" rx="18" ry="10" fill="#6B9E47" data-id="element-818" data-mp="9nh8hbkuo44r" />
              <ellipse cx="458" cy="144" rx="12" ry="8" fill="#7BAF52" data-id="element-819" data-mp="11aittpt0larc" />
              <ellipse cx="478" cy="144" rx="12" ry="8" fill="#7BAF52" data-id="element-820" data-mp="11btzjv60ssl3" />
            </g>

            {/* ── COBBLESTONE PATH — shadow layer ── */}
            <path d={PATH} stroke="#C4A882" strokeWidth="22" fill="none" strokeLinecap="round" opacity="0.28" data-id="element-821" data-mp="rbtcby515sbm" />
            {/* Cobblestone base */}
            <path d={PATH} stroke="#A0845C" strokeWidth="14" fill="none" strokeLinecap="round" strokeDasharray="10 5" opacity="0.50" data-id="element-822" data-mp="1k08omcws1wj9" />
            {/* Cobblestone inner */}
            <path d={PATH} stroke="#D4B896" strokeWidth="8" fill="none" strokeLinecap="round" strokeDasharray="7 8" opacity="0.55" data-id="element-823" data-mp="15bck2ptxj1ne" />
            {/* Cobblestone highlight */}
            <path d={PATH} stroke="#F0E0C8" strokeWidth="3" fill="none" strokeLinecap="round" strokeDasharray="5 10" opacity="0.40" data-id="element-824" data-mp="26ah3v9eqi5o7" />

            {/* ── PROGRESS PATH (magical glow) ── */}
            <path d={PATH} stroke="#7C4DFF" strokeWidth="10" fill="none" strokeLinecap="round" opacity="0.70" style={{
            strokeDasharray: TOTAL_LEN,
            strokeDashoffset: TOTAL_LEN - progressLen,
            transition: 'stroke-dashoffset 800ms cubic-bezier(0.4,0,0.2,1)',
            filter: 'url(#map-glow)'
          }} data-id="element-825" data-mp="2ka8bmsenqptr" />
            {/* Animated flowing light */}
            {completedCount < 4 && <path d={PATH} stroke="#B388FF" strokeWidth="5" fill="none" strokeLinecap="round" style={{
            strokeDasharray: '30 810',
            strokeDashoffset: TOTAL_LEN - progressLen - 15,
            animation: 'path-flow 1.8s linear infinite',
            opacity: 0.85
          }} data-id="element-826" data-mp="37wyetx2qsqfy" />}

            {/* ── PATH SPARKLES ── */}
            {[{
            x: 260,
            y: 90,
            delay: '0s',
            size: 14
          }, {
            x: 390,
            y: 320,
            delay: '0.6s',
            size: 11
          }, {
            x: 260,
            y: 400,
            delay: '1.2s',
            size: 13
          }, {
            x: 260,
            y: 570,
            delay: '0.3s',
            size: 10
          }].map((s, i) => <text key={i} x={s.x} y={s.y} textAnchor="middle" fontSize={s.size} fill="#FFD700" filter="url(#map-glow)" style={{
            animation: `map-sparkle ${2.2 + i * 0.4}s ease-in-out infinite`,
            animationDelay: s.delay
          }} data-id="element-827" data-mp="3jz8jl9q1hkh4" data-mpi={i}>
                ✦
              </text>)}

            {/* ── COMPASS ── */}
            <g transform="translate(472, 636)" opacity="0.75" data-id="element-828" data-mp="1lnf4k2urfjvy">
              <circle cx="0" cy="0" r="22" fill="#F0E8D0" stroke="#8B6914" strokeWidth="1.5" data-id="element-829" data-mp="1lozz3sh2r2tt" />
              <circle cx="0" cy="0" r="18" fill="none" stroke="#8B6914" strokeWidth="0.5" opacity="0.5" data-id="element-830" data-mp="1bpiwjjx4d522" />
              <text x="0" y="-10" textAnchor="middle" fontSize="7" fill="#8B6914" fontWeight="bold" data-id="element-831" data-mp="iut5ws9senuy">
                N
              </text>
              <text x="0" y="15" textAnchor="middle" fontSize="7" fill="#8B6914" fontWeight="bold" data-id="element-832" data-mp="9uxpa7xgq0nj">
                S
              </text>
              <text x="13" y="3" textAnchor="middle" fontSize="7" fill="#8B6914" fontWeight="bold" data-id="element-833" data-mp="xjpd6n40rwui">
                E
              </text>
              <text x="-13" y="3" textAnchor="middle" fontSize="7" fill="#8B6914" fontWeight="bold" data-id="element-834" data-mp="nt4b2pp50a6u">
                W
              </text>
              <polygon points="0,-14 2.5,-3 0,-6 -2.5,-3" fill="#C0392B" data-id="element-835" data-mp="1ntzg2ouvmyvq" />
              <polygon points="0,14 2.5,3 0,6 -2.5,3" fill="#8B6914" opacity="0.7" data-id="element-836" data-mp="1nvu5ogh3ff65" />
              <circle cx="0" cy="0" r="2.5" fill="#8B6914" data-id="element-837" data-mp="1xrnmic1uhutq" />
            </g>

            {/* ── DECORATIVE NATURE ICONS ── */}
            <text x="18" y="200" fontSize="16" opacity="0.45" style={{
            animation: 'map-float 4s ease-in-out infinite'
          }} data-id="element-838" data-mp="21v25nbl2yrbe">
              🌿
            </text>
            <text x="490" y="390" fontSize="14" opacity="0.40" style={{
            animation: 'map-float 5s ease-in-out infinite',
            animationDelay: '1s'
          }} data-id="element-839" data-mp="2gi52rh5hqxy7">
              🍃
            </text>
            <text x="240" y="168" fontSize="12" opacity="0.35" style={{
            animation: 'map-sparkle 3s ease-in-out infinite',
            animationDelay: '0.5s'
          }} data-id="element-840" data-mp="2uj7nnqkr227j">
              ⭐
            </text>
            <text x="270" y="490" fontSize="10" opacity="0.30" style={{
            animation: 'map-sparkle 4s ease-in-out infinite',
            animationDelay: '1.5s'
          }} data-id="element-841" data-mp="2qkqxdn72p4r2">
              ✨
            </text>
            <text x="60" y="460" fontSize="13" opacity="0.40" style={{
            animation: 'map-float 6s ease-in-out infinite',
            animationDelay: '2s'
          }} data-id="element-842" data-mp="1twt2ijaz91jr">
              🌸
            </text>
          </svg>

          {/* ── BUILDING NODES ── */}
          {BUILDINGS.map((b, i) => {
          const {
            cx,
            cy
          } = buildingPositions[i];
          const status = i < completedCount ? 'completed' : i === completedCount ? 'active' : 'locked';
          const BuildingSVG = BUILDING_SVGS[i];
          const nodeW = 80;
          const nodeH = 88;
          return <div key={b.id} className="absolute flex flex-col items-center" style={{
            left: cx - nodeW / 2 - 30,
            top: cy - nodeH / 2 - 10,
            width: nodeW + 60,
            zIndex: status === 'active' ? 20 : 10
          }} data-id="element-843" data-mp="w29ul9tl2ehc" data-mpi={i}>
                <button onClick={() => openMission(b.id)} disabled={status === 'locked'} className="relative flex flex-col items-center group" style={{
              cursor: status === 'locked' ? 'not-allowed' : 'pointer'
            }} data-id="element-844" data-mp="1f0cpg58tb5n2">
                  {/* Active glow ring */}
                  {status === 'active' && <div className="absolute rounded-full pointer-events-none" style={{
                inset: -12,
                background: `radial-gradient(circle, ${b.color}28 0%, transparent 70%)`,
                animation: 'node-pulse 2s ease infinite'
              }} data-id="element-845" data-mp="2cd9ji0sp70y1" />}

                  {/* Building illustration */}
                  <div className="relative transition-transform duration-300" style={{
                width: nodeW,
                height: nodeH,
                filter: status === 'locked' ? 'grayscale(0.85) opacity(0.5)' : status === 'active' ? `drop-shadow(0 8px 20px ${b.color}55)` : `drop-shadow(0 4px 10px ${b.color}30)`,
                transform: status === 'active' ? 'scale(1.10)' : 'scale(1)',
                animation: status === 'active' ? 'building-active-glow 2.5s ease-in-out infinite' : 'none'
              }} data-id="element-846" data-mp="1tkypyxjxofcl">
                    <BuildingSVG data-id="element-847" data-mp="32ol4gqyznpqh" />

                    {/* Completed badge */}
                    {status === 'completed' && <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-green-500 flex items-center justify-center shadow-md border-2 border-white" data-id="element-848" data-mp="37mwi7csemkdz">
                        <Check size={13} color="white" strokeWidth={3} data-id="element-849" data-mp="3hdhkpbb78926" />
                      </div>}

                    {/* Meelo on active */}
                    {status === 'active' && <div className="absolute -top-4 -right-4 w-10 h-10 rounded-full bg-white border-2 overflow-hidden shadow-lg" style={{
                  borderColor: b.color,
                  animation: 'meelo-bounce 2s ease-in-out infinite'
                }} data-id="element-850" data-mp="2oukeomq0ld29">
                        <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-851" data-mp="1m9wj4q2ibf7y" />
                      </div>}
                  </div>

                  {/* Fog overlay for locked */}
                  {status === 'locked' && <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
                background: 'rgba(246,241,232,0.55)',
                backdropFilter: 'blur(1.5px)',
                animation: 'fog-drift 4s ease-in-out infinite'
              }} data-id="element-852" data-mp="260i2m3vp77x6" />}

                  {/* Lock icon for locked */}
                  {status === 'locked' && <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 rounded-full bg-white/80 flex items-center justify-center shadow-sm border border-gray-200" style={{
                animation: 'meelo-bounce 3s ease-in-out infinite'
              }} data-id="element-853" data-mp="2om653ks4f7sd">
                      <Lock size={11} color="#9CA3AF" data-id="element-854" data-mp="25wpycfpuej3i" />
                    </div>}

                  {/* Building name */}
                  <div className="mt-2 text-center" style={{
                width: nodeW + 60
              }} data-id="element-855" data-mp="2avsrp2wgn0vn">
                    <p className="text-xs font-bold leading-tight" style={{
                  color: status === 'locked' ? '#B8A880' : '#3D2800',
                  opacity: status === 'locked' ? 0.6 : 1
                }} data-id="element-856" data-mp="20vtlvdrfdomh">
                      {b.name}
                    </p>
                    {status === 'active' && <p className="text-[10px] font-bold mt-0.5 animate-pulse" style={{
                  color: b.color
                }} data-id="element-857" data-mp="12txk8zj03t7f">
                        ▶ Нажми
                      </p>}
                    {status === 'completed' && <p className="text-[10px] text-green-600 font-semibold mt-0.5" data-id="element-858" data-mp="1ljdljp2ifpow">
                        ✓ Выполнено
                      </p>}
                  </div>
                </button>
              </div>;
        })}
        </div>

        {/* ── MOBILE MAP — vertical parchment scroll ── */}
        <div className="sm:hidden flex flex-col items-center gap-0 relative" data-id="element-859" data-mp="3f34hfw2altxz">
          {/* Winding SVG path behind buildings */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 200 480" preserveAspectRatio="xMidYMid meet" style={{
          overflow: 'visible'
        }} data-id="element-860" data-mp="3b2c872tf7p1p">
            <defs data-id="element-861" data-mp="2j4ppguc86dq">
              <filter id="mobile-glow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-862" data-mp="2jd0n36wh1ma">
                <feGaussianBlur stdDeviation="3" result="blur" data-id="element-863" data-mp="3oyfwygliz56s" />
                <feMerge data-id="element-864" data-mp="3k0xp6tj8uw0d">
                  <feMergeNode in="blur" data-id="element-865" data-mp="3jzml0slvzm8q" />
                  <feMergeNode in="SourceGraphic" data-id="element-866" data-mp="3jytki9ditsz1" />
                </feMerge>
              </filter>
            </defs>
            {/* Cobblestone shadow */}
            <path d="M 100,20 C 60,80 140,140 100,200 C 60,260 140,320 100,380 C 70,430 100,460 100,460" stroke="#C4A882" strokeWidth="18" fill="none" strokeLinecap="round" opacity="0.25" data-id="element-867" data-mp="giw6fpc8o0vf" />
            {/* Cobblestone base */}
            <path d="M 100,20 C 60,80 140,140 100,200 C 60,260 140,320 100,380 C 70,430 100,460 100,460" stroke="#A0845C" strokeWidth="12" fill="none" strokeLinecap="round" strokeDasharray="10 5" opacity="0.45" data-id="element-868" data-mp="211px04prcwww" />
            {/* Cobblestone inner */}
            <path d="M 100,20 C 60,80 140,140 100,200 C 60,260 140,320 100,380 C 70,430 100,460 100,460" stroke="#D4B896" strokeWidth="6" fill="none" strokeLinecap="round" strokeDasharray="7 8" opacity="0.50" data-id="element-869" data-mp="1i3vso3zkr9ku" />
            {/* Progress glow */}
            <path d="M 100,20 C 60,80 140,140 100,200 C 60,260 140,320 100,380 C 70,430 100,460 100,460" stroke="#7C4DFF" strokeWidth="8" fill="none" strokeLinecap="round" opacity="0.65" style={{
            strokeDasharray: 600,
            strokeDashoffset: 600 - completedCount / 4 * 600,
            transition: 'stroke-dashoffset 800ms cubic-bezier(0.4,0,0.2,1)',
            filter: 'url(#mobile-glow)'
          }} data-id="element-870" data-mp="3he58m7svtzuq" />
          </svg>

          {BUILDINGS.map((b, i) => {
          const status = i < completedCount ? 'completed' : i === completedCount ? 'active' : 'locked';
          const BuildingSVG = BUILDING_SVGS[i];
          return <div key={b.id} className="relative z-10 flex flex-col items-center py-6" data-id="element-871" data-mp="2oxtl7wagfczu" data-mpi={i}>
                <button onClick={() => openMission(b.id)} disabled={status === 'locked'} className="flex flex-col items-center" data-id="element-872" data-mp="2ky2jwynaxeh2">
                  <div className="relative mb-2" style={{
                width: 72,
                height: 80,
                filter: status === 'locked' ? 'grayscale(0.85) opacity(0.5)' : status === 'active' ? `drop-shadow(0 6px 14px ${b.color}55)` : `drop-shadow(0 3px 8px ${b.color}30)`,
                transform: status === 'active' ? 'scale(1.1)' : 'scale(1)',
                transition: 'transform 300ms ease',
                animation: status === 'active' ? 'building-active-glow 2.5s ease-in-out infinite' : 'none'
              }} data-id="element-873" data-mp="2vdk0vbtdhv7h">
                    <BuildingSVG data-id="element-874" data-mp="1hbvzsnhoo3dd" />
                    {status === 'completed' && <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-green-500 flex items-center justify-center shadow-md border-2 border-white" data-id="element-875" data-mp="1cfosordjwltu">
                        <Check size={11} color="white" strokeWidth={3} data-id="element-876" data-mp="13eyz7ubrj7ja" />
                      </div>}
                    {status === 'active' && <div className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-white border-2 overflow-hidden shadow-lg" style={{
                  borderColor: b.color,
                  animation: 'meelo-bounce 2s ease-in-out infinite'
                }} data-id="element-877" data-mp="toe62meuyv7r">
                        <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-878" data-mp="fntlpltaorc5" />
                      </div>}
                    {status === 'locked' && <>
                        <div className="absolute inset-0 rounded-xl pointer-events-none" style={{
                    background: 'rgba(246,241,232,0.50)',
                    backdropFilter: 'blur(1.5px)',
                    animation: 'fog-drift 4s ease-in-out infinite'
                  }} data-id="element-879" data-mp="3nb8ms2ufevmj" />
                        <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-5 h-5 rounded-full bg-white/80 flex items-center justify-center shadow-sm border border-gray-200" data-id="element-880" data-mp="a0hw2dr2x4r0">
                          <Lock size={9} color="#9CA3AF" data-id="element-881" data-mp="12pymx6z1wdl4" />
                        </div>
                      </>}
                  </div>
                  <p className="text-sm font-bold text-center max-w-[160px] leading-tight" style={{
                color: status === 'locked' ? '#B8A880' : '#3D2800',
                opacity: status === 'locked' ? 0.6 : 1
              }} data-id="element-882" data-mp="2s7ls5i3lf6oc">
                    {b.name}
                  </p>
                  {status === 'active' && <p className="text-xs font-bold mt-1 animate-pulse" style={{
                color: b.color
              }} data-id="element-883" data-mp="29akk1oeqsqg6">
                      ▶ Нажми
                    </p>}
                  {status === 'completed' && <p className="text-xs text-green-600 font-semibold mt-1" data-id="element-884" data-mp="2dd8uu1n0o7fs">
                      ✓ Выполнено
                    </p>}
                </button>
              </div>;
        })}
        </div>

        {/* ── MEELO MAP MESSAGE ── */}
        <div className="flex items-center justify-center gap-3 mt-10 transition-opacity duration-500" style={{
        opacity: 0.4
      }} data-id="element-885" data-mp="cobdlni5jksq">
          <div className="rounded-2xl rounded-tl-sm px-4 py-2.5 shadow-sm max-w-xs" style={{
          background: 'rgba(255,255,255,0.80)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(139,105,20,0.18)'
        }} data-id="element-886" data-mp="lmnau8dixgu5">
            <p className="text-sm leading-relaxed" style={{
            color: '#5D3A00'
          }} data-id="element-887" data-mp="10bt4lgtleeun">
              {MEELO_MSGS[completedCount]}
            </p>
          </div>
        </div>
      </div>
    </section>;
}
// ── Main Page ──────────────────────────────────────────────────────────────
export function MissionPage() {
  const [completed, setCompleted] = useState<Set<number>>(new Set());
  const [activeMission, setActiveMission] = useState<number | null>(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMsg, setToastMsg] = useState('');
  const [showConfetti, setShowConfetti] = useState(false);
  const [showCompletionOverlay, setShowCompletionOverlay] = useState(false);
  const toastTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const confettiTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const completedCount = completed.size;
  const progress = completedCount * 25;
  const chaos = CHAOS[completedCount];
  const energy = ENERGY[completedCount];
  const allDone = completedCount === 4;
  // Show completion overlay with a short delay after finishing
  useEffect(() => {
    if (allDone) {
      const t = setTimeout(() => setShowCompletionOverlay(true), 1200);
      return () => clearTimeout(t);
    }
  }, [allDone]);
  const handleComplete = useCallback((id: number) => {
    if (completed.has(id)) return;
    setCompleted(prev => new Set([...prev, id]));
    setActiveMission(null);
    playChime();
    setShowConfetti(true);
    if (confettiTimer.current) clearTimeout(confettiTimer.current);
    confettiTimer.current = setTimeout(() => setShowConfetti(false), 2000);
    const toasts = ['Хаос ↓ до 70%', 'Хаос ↓ до 45%', 'Хаос ↓ до 20%', '🏆 Хаос = 0%!'];
    setToastMsg(`✓ Миссия ${id} выполнена — ${toasts[id - 1]}`);
    setToastVisible(true);
    if (toastTimer.current) clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToastVisible(false), 3500);
  }, [completed]);
  const openMission = (id: number) => {
    if (id > completedCount + 1) return;
    setActiveMission(id);
  };
  useEffect(() => {
    return () => {
      if (toastTimer.current) clearTimeout(toastTimer.current);
      if (confettiTimer.current) clearTimeout(confettiTimer.current);
    };
  }, []);
  const activeBuilding = activeMission !== null ? BUILDINGS[activeMission - 1] : null;
  return <div className="min-h-screen font-sans text-gray-900 bg-[#FAFAFA]" data-id="element-888" data-mp="3d2qwnk00m9jq">
      <MissionNavbar data-id="element-889" data-mp="3i1281z5yks42" />
      <ProgressPill progress={progress} data-id="element-890" data-mp="3i098bi5f32vf" />
      <Confetti active={showConfetti} data-id="element-891" data-mp="3i1bw3h7g0p74" />

      {/* ── HERO ─────────────────────────────────────────────────────── */}
      <section className="relative overflow-hidden flex flex-col items-center justify-center text-center" style={{
      background: 'linear-gradient(180deg, #1A0A3E 0%, #2D1B69 18%, #6B3FA0 42%, #C4956A 72%, #F0E4C8 100%)',
      minHeight: '100dvh',
      paddingTop: 'clamp(5rem, 10vw, 7rem)',
      paddingBottom: 'clamp(4rem, 8vw, 6rem)'
    }} data-id="element-892" data-mp="3myaonvbgko37">
        {/* ── PARCHMENT TEXTURE (subtle) ── */}
        <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.03'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat'
      }} data-id="element-893" data-mp="ej0t7622qh4e" />

        {/* ── VIGNETTE ── */}
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 90% 90% at 50% 50%, transparent 55%, rgba(10,0,30,0.35) 100%)'
      }} data-id="element-894" data-mp="2d9kipn08vsl6" />

        {/* ── STARS (fixed positions, no Math.random) ── */}
        {[{
        top: '8%',
        left: '12%',
        size: 3,
        delay: '0s',
        dur: '3s'
      }, {
        top: '14%',
        left: '72%',
        size: 2,
        delay: '0.8s',
        dur: '4s'
      }, {
        top: '6%',
        left: '45%',
        size: 2.5,
        delay: '1.5s',
        dur: '3.5s'
      }, {
        top: '20%',
        left: '88%',
        size: 2,
        delay: '0.3s',
        dur: '5s'
      }, {
        top: '11%',
        left: '28%',
        size: 1.5,
        delay: '2s',
        dur: '4.5s'
      }, {
        top: '18%',
        left: '58%',
        size: 2,
        delay: '1s',
        dur: '3.8s'
      }, {
        top: '25%',
        left: '8%',
        size: 1.5,
        delay: '0.5s',
        dur: '4.2s'
      }].map((s, i) => <div key={i} className="absolute rounded-full pointer-events-none" style={{
        top: s.top,
        left: s.left,
        width: s.size,
        height: s.size,
        background: 'rgba(255,255,255,0.9)',
        boxShadow: `0 0 ${s.size * 2}px rgba(255,255,255,0.6)`,
        animation: `chaos-float-${i % 4 + 1} ${s.dur} ease-in-out infinite`,
        animationDelay: s.delay
      }} data-id="element-895" data-mp="2wtsuwkbjqahe" data-mpi={i} />)}

        {/* ── CRESCENT MOON ── */}
        <div className="absolute pointer-events-none" style={{
        top: '9%',
        right: '10%',
        opacity: 0.75
      }} data-id="element-896" data-mp="3lgvb4wfvpvww">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" data-id="element-897" data-mp="3bk8t0fextiyk">
            <circle cx="18" cy="18" r="14" fill="#FFD97A" opacity="0.9" data-id="element-898" data-mp="3bhcwmviqn2c8" />
            <circle cx="24" cy="13" r="12" fill="#2D1B69" data-id="element-899" data-mp="36jba20m3skw0" />
          </svg>
        </div>

        {/* ── SOFT CLOUD BLOBS ── */}
        <div className="absolute pointer-events-none" style={{
        top: '28%',
        left: '4%',
        width: 140,
        height: 50,
        background: 'rgba(180,140,255,0.10)',
        borderRadius: '50%',
        filter: 'blur(22px)',
        animation: 'cloud-drift-1 30s ease-in-out infinite'
      }} data-id="element-900" data-mp="2xjy0l7xzbwba" />
        <div className="absolute pointer-events-none" style={{
        top: '22%',
        right: '6%',
        width: 110,
        height: 40,
        background: 'rgba(200,160,255,0.08)',
        borderRadius: '50%',
        filter: 'blur(18px)',
        animation: 'cloud-drift-2 38s ease-in-out infinite'
      }} data-id="element-901" data-mp="139zvtv2lzjg1" />

        {/* ── HERO CONTENT ── */}
        <div className="relative z-10 flex flex-col items-center w-full max-w-sm px-6" style={{
        animation: 'fadeInUp 0.9s ease-out forwards'
      }} data-id="element-902" data-mp="pcb7gd9c1u68">
          {/* 1. Eyebrow */}
          <p className="text-[11px] font-bold tracking-widest uppercase mb-3" style={{
          color: 'rgba(255,215,0,0.75)',
          letterSpacing: '0.20em'
        }} data-id="element-903" data-mp="yd9fd6mw6lu3">
            ⭐ ДЛЯ РУКОВОДИТЕЛЕЙ ДЕТСКИХ САДОВ ⭐
          </p>

          {/* 2. Main headline */}
          <h1 className="text-3xl sm:text-4xl font-bold leading-tight mb-2 text-center" style={{
          color: 'rgba(255,255,255,0.97)',
          textShadow: '0 2px 20px rgba(100,50,200,0.40)'
        }} data-id="element-904" data-mp="am3iss655sp6">
            У вас детский сад?
          </h1>

          {/* 3. Subheadline */}
          <p className="text-sm sm:text-base font-medium leading-relaxed mb-6 text-center" style={{
          color: 'rgba(240,228,200,0.80)',
          maxWidth: 280
        }} data-id="element-905" data-mp="en6xhbcgdiot">
            Тогда сыграйте и проверьте,
            <br data-id="element-906" data-mp="qtbbowz4t40" />
            что съедает ваш день.
          </p>

          {/* 4. Meelo avatar */}
          <div className="relative flex flex-col items-center mb-4" data-id="element-907" data-mp="3s2d028ptzx7e">
            {/* Glow ring */}
            <div className="absolute rounded-full pointer-events-none" style={{
            width: 200,
            height: 200,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'radial-gradient(circle, rgba(180,120,255,0.28) 0%, rgba(255,200,80,0.12) 50%, transparent 70%)',
            animation: 'node-pulse 2.8s ease-in-out infinite'
          }} data-id="element-908" data-mp="34cr03j1mxdyc" />
            {/* Avatar */}
            <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full overflow-hidden shadow-2xl" style={{
            background: 'rgba(255,255,255,0.95)',
            border: '3px solid rgba(255,215,0,0.45)',
            animation: 'meelo-bounce 2.4s ease-in-out infinite',
            boxShadow: '0 8px 40px rgba(100,50,200,0.30), 0 0 0 6px rgba(255,215,0,0.08)'
          }} data-id="element-909" data-mp="1ylgntr18n9qo">
              <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-2" data-id="element-910" data-mp="d6jaegsbve89" />
            </div>

            {/* 5. Greeting card / speech bubble */}
            <div className="mt-3 rounded-2xl rounded-t-sm px-4 py-3 w-full" style={{
            background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(16px)',
            border: '1.5px solid rgba(255,255,255,0.6)',
            boxShadow: '0 6px 24px rgba(100,50,200,0.18)'
          }} data-id="element-911" data-mp="14u47ftzjud0f">
              <p className="text-sm font-semibold text-[#3D1A8A] leading-relaxed text-center" data-id="element-912" data-mp="1nmycnw7deqrg">
                Привет! Я Meelo — умная система управления детским садом:
                упрощаю операционку. 💜
              </p>
            </div>
          </div>

          {/* 6 & 7 & hint. CTAs */}
          <div className="flex flex-col items-center gap-2 w-full" data-id="element-913" data-mp="2bcj6xb8z5ag1">
            <button onClick={() => document.getElementById('map-section')?.scrollIntoView({
            behavior: 'smooth'
          })} className="inline-flex items-center justify-center gap-2 w-full max-w-xs py-4 rounded-full font-bold text-lg transition-all active:scale-95" style={{
            background: 'linear-gradient(135deg, #FFD700 0%, #E8A800 100%)',
            color: '#3D1A00',
            boxShadow: '0 0 32px rgba(200,160,0,0.50), 0 4px 16px rgba(0,0,0,0.15)'
          }} data-id="element-914" data-mp="26l15km31h7uj">
              🎮 Сыграть
            </button>

            {/* Micro-game hint */}
            <p className="text-xs font-medium" style={{
            color: 'rgba(240,228,200,0.55)'
          }} data-id="element-915" data-mp="36k31z0elv28s">
              ⏱ Займёт 30 секунд
            </p>

            {/* Secondary link */}
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-sm font-medium transition-opacity hover:opacity-80 mt-1" style={{
            color: 'rgba(245,237,216,0.55)'
          }} data-id="element-916" data-mp="3gklraaoxvay3">
              Хочу демо →
            </a>
          </div>
        </div>

        {/* ── SIMPLE CASTLE SILHOUETTE ── */}
        <div className="absolute bottom-0 left-0 right-0 pointer-events-none" style={{
        zIndex: 1
      }} data-id="element-917" data-mp="m514ooy7ev81">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="xMidYMax meet" className="w-full" style={{
          display: 'block'
        }} data-id="element-918" data-mp="19vwq94c2gu6u">
            {/* Left castle */}
            <g fill="#0D0520" opacity="0.55" data-id="element-919" data-mp="153vjfxxo3vo7">
              <rect x="60" y="60" width="8" height="8" data-id="element-920" data-mp="152ty90mxtssr" />
              <rect x="70" y="60" width="8" height="8" data-id="element-921" data-mp="1sthi8ka4o8vo" />
              <rect x="80" y="60" width="8" height="8" data-id="element-922" data-mp="1srwo2vrq6ryc" />
              <rect x="58" y="68" width="34" height="52" data-id="element-923" data-mp="1xkps1hfddw9d" />
              <rect x="40" y="72" width="12" height="48" data-id="element-924" data-mp="1xmalf3py795n" />
              <rect x="38" y="66" width="4" height="8" data-id="element-925" data-mp="3i9jrd1cpjayx" />
              <rect x="44" y="66" width="4" height="8" data-id="element-926" data-mp="3dbi8agfa7bng" />
              <rect x="94" y="72" width="12" height="48" data-id="element-927" data-mp="3daqkvsvu8k89" />
              <rect x="92" y="66" width="4" height="8" data-id="element-928" data-mp="3s04vf4b5h7p8" />
              <rect x="98" y="66" width="4" height="8" data-id="element-929" data-mp="3rzmqzkec3n68" />
              <rect x="70" y="88" width="10" height="32" rx="5" data-id="element-930" data-mp="3n11thsqgvhlh" />
              <line x1="75" y1="50" x2="75" y2="68" stroke="#0D0520" strokeWidth="1.5" data-id="element-931" data-mp="2zbqyyszpmjfs" />
              <polygon points="75,50 83,57 75,64" fill="#3D1A8A" opacity="0.7" data-id="element-932" data-mp="399wzp79s5jj2" />
            </g>
            {/* Right castle */}
            <g fill="#0D0520" opacity="0.50" data-id="element-933" data-mp="34d6lkphjcy0a">
              <rect x="1100" y="55" width="8" height="8" data-id="element-934" data-mp="oimr36ul6itk" />
              <rect x="1110" y="55" width="8" height="8" data-id="element-935" data-mp="jkl9kqct6rk7" />
              <rect x="1120" y="55" width="8" height="8" data-id="element-936" data-mp="jk34d4865305" />
              <rect x="1098" y="63" width="34" height="57" data-id="element-937" data-mp="qoaz00s2ybrt" />
              <rect x="1080" y="68" width="12" height="52" data-id="element-938" data-mp="qpvuptq4s0r9" />
              <rect x="1078" y="62" width="4" height="8" data-id="element-939" data-mp="vlupbz21yf04" />
              <rect x="1084" y="62" width="4" height="8" data-id="element-940" data-mp="10lz5fnz1t7pt" />
              <rect x="1134" y="68" width="12" height="52" data-id="element-941" data-mp="10mic28j909oj" />
              <rect x="1132" y="62" width="4" height="8" data-id="element-942" data-mp="15llinxevmnym" />
              <rect x="1138" y="62" width="4" height="8" data-id="element-943" data-mp="15izabvk5w4fc" />
              <rect x="1110" y="84" width="10" height="36" rx="5" data-id="element-944" data-mp="7ycrbls72kop" />
            </g>
            {/* Center distant tower */}
            <g fill="#0D0520" opacity="0.30" data-id="element-945" data-mp="cwo2bzu8718i">
              <rect x="585" y="75" width="5" height="6" data-id="element-946" data-mp="huxxiafya1u4" />
              <rect x="592" y="75" width="5" height="6" data-id="element-947" data-mp="hu69plslh8ee" />
              <rect x="583" y="81" width="20" height="39" data-id="element-948" data-mp="mmg1z8h6mkju" />
              <polygon points="593,65 602,81 584,81" data-id="element-949" data-mp="mo0r2ikq9bab" />
            </g>
            {/* Ground hill */}
            <ellipse cx="600" cy="125" rx="700" ry="40" fill="#0D0520" opacity="0.40" data-id="element-950" data-mp="3qbayacnemdsd" />
            <ellipse cx="150" cy="125" rx="250" ry="35" fill="#0D0520" opacity="0.35" data-id="element-951" data-mp="27e2apvb6p6xk" />
            <ellipse cx="1050" cy="125" rx="250" ry="35" fill="#0D0520" opacity="0.35" data-id="element-952" data-mp="1ydnei0wom7fa" />
          </svg>
        </div>
      </section>

      {/* ── ADVENTURE MAP ────────────────────────────────────────────── */}
      <AdventureMap completedCount={completedCount} openMission={openMission} allDone={allDone} data-id="element-953" data-mp="1johguhdhsp9i" />

      {/* ── COMPLETION OVERLAY ───────────────────────────────────────── */}
      {showCompletionOverlay && <div className="fixed inset-0 flex items-center justify-center px-4" style={{
      zIndex: 150,
      background: '#F6F1E8',
      animation: 'completion-fade-in 700ms cubic-bezier(0.16,1,0.3,1) forwards'
    }} data-id="element-954" data-mp="15rcd4o1942hf">
          {/* Parchment texture */}
          <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.045'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat'
      }} data-id="element-955" data-mp="35rr3r1skckye" />

          {/* Sunlight rays */}
          <div className="absolute pointer-events-none" style={{
        top: '-10%',
        left: '50%',
        width: '140%',
        maxWidth: 900,
        aspectRatio: '1',
        animation: 'sunray-rotate 60s linear infinite'
      }} data-id="element-956" data-mp="2d3lkkjh5r40o">
            <svg viewBox="0 0 800 800" fill="none" className="w-full h-full" data-id="element-957" data-mp="1vvlxwi85vuxb">
              {Array.from({
            length: 18
          }).map((_, i) => <line key={i} x1="400" y1="400" x2={400 + Math.cos(i / 18 * Math.PI * 2) * 600} y2={400 + Math.sin(i / 18 * Math.PI * 2) * 600} stroke="rgba(255,210,80,0.07)" strokeWidth="55" data-id="element-958" data-mp="25l5hxr7m1utr" data-mpi={i} />)}
            </svg>
          </div>

          {/* Warm radial glow */}
          <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 70% 65% at 50% 42%, rgba(255,220,120,0.28) 0%, transparent 70%)'
      }} data-id="element-959" data-mp="2oiezt3xaf08w" />

          {/* Vignette */}
          <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 88% 88% at 50% 50%, transparent 55%, rgba(140,100,40,0.18) 100%)'
      }} data-id="element-960" data-mp="p7nos6t201so" />

          {/* Decorative border frame */}
          <div className="absolute inset-4 sm:inset-8 pointer-events-none rounded-2xl" style={{
        border: '2px solid rgba(139,105,20,0.22)',
        boxShadow: 'inset 0 0 60px rgba(139,105,20,0.06)'
      }} data-id="element-961" data-mp="2y8idfeicaz74" />

          {/* Corner ornaments */}
          {[{
        top: 14,
        left: 14
      }, {
        top: 14,
        right: 14
      }, {
        bottom: 14,
        left: 14
      }, {
        bottom: 14,
        right: 14
      }].map((pos, i) => <div key={i} className="absolute text-xl pointer-events-none select-none" style={{
        ...pos,
        color: '#8B6914',
        opacity: 0.35
      }} data-id="element-962" data-mp="3vxbt2y0qtp6g" data-mpi={i}>
              ✦
            </div>)}

          {/* Floating sparkles */}
          {[{
        top: '15%',
        left: '12%',
        size: 14,
        delay: '0s'
      }, {
        top: '20%',
        right: '10%',
        size: 11,
        delay: '0.4s'
      }, {
        top: '70%',
        left: '8%',
        size: 10,
        delay: '0.8s'
      }, {
        top: '75%',
        right: '12%',
        size: 13,
        delay: '0.2s'
      }, {
        top: '45%',
        left: '4%',
        size: 9,
        delay: '1.2s'
      }, {
        top: '40%',
        right: '5%',
        size: 10,
        delay: '0.6s'
      }].map((s, i) => <div key={i} className="absolute pointer-events-none select-none" style={{
        ...s,
        fontSize: s.size,
        color: '#C4A040',
        animation: `map-sparkle 2.5s ease-in-out infinite`,
        animationDelay: s.delay
      }} data-id="element-963" data-mp="1v0vzpkdaw6w9" data-mpi={i}>
              ✦
            </div>)}

          {/* ── MAIN CONTENT ── */}
          <div className="relative z-10 max-w-lg w-full mx-auto text-center" style={{
        animation: 'completion-meelo-entrance 900ms 200ms cubic-bezier(0.16,1,0.3,1) both'
      }} data-id="element-964" data-mp="2dyp4ytbecswt">
            {/* Achievement badge */}
            <div className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-6" style={{
          color: '#8B6914',
          background: 'rgba(139,105,20,0.12)',
          border: '1px solid rgba(139,105,20,0.28)'
        }} data-id="element-965" data-mp="nn18qnzarnpa">
              ⚔️ 4 монстра повержены
            </div>

            {/* Meelo — large, centered */}
            <div className="relative inline-flex flex-col items-center mb-2" data-id="element-966" data-mp="3fsqr6fq3wst3">
              {/* Outer glow ring */}
              <div className="absolute rounded-full pointer-events-none" style={{
            inset: -20,
            background: 'radial-gradient(circle, rgba(255,215,0,0.20) 0%, transparent 70%)',
            animation: 'node-pulse 2.5s ease-in-out infinite'
          }} data-id="element-967" data-mp="2o3oopzhoyxvn" />
              {/* Avatar */}
              <div className="w-28 h-28 rounded-full overflow-hidden" style={{
            background: 'rgba(255,255,255,0.95)',
            border: '4px solid rgba(255,215,0,0.55)',
            animation: 'meelo-bounce 2.2s ease-in-out infinite, golden-pulse 2.5s ease-in-out infinite',
            boxShadow: '0 8px 40px rgba(139,105,20,0.22)'
          }} data-id="element-968" data-mp="2s3flqkxtaa8m">
                <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-2" data-id="element-969" data-mp="2jk2zqvjonab1" />
              </div>
            </div>

            {/* Meelo speech bubble */}
            <div className="mx-auto mb-5 rounded-3xl rounded-t-sm px-5 py-4 max-w-sm" style={{
          background: 'rgba(255,255,255,0.88)',
          backdropFilter: 'blur(16px)',
          border: '1.5px solid rgba(139,105,20,0.20)',
          boxShadow: '0 8px 32px rgba(139,105,20,0.12)'
        }} data-id="element-970" data-mp="1lzgkmwuu6apo">
              <p className="text-sm font-medium leading-relaxed" style={{
            color: '#5D3A00'
          }} data-id="element-971" data-mp="136cnv2mbnhqu">
                Вы победили всех четырёх монстров хаоса.{' '}
                <span className="font-bold" style={{
              color: '#3D2800'
            }} data-id="element-972" data-mp="34wbl4gsril2w">
                  Гримрак, Сталеарх, Златохват и Шуморяд — все повержены.
                </span>{' '}
                Но это была симуляция. Представьте, если Meelo сделает это в
                вашем реальном саду.
              </p>
            </div>

            {/* Defeated monsters row */}
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-973" data-mp="3ojrdyaxof3ua">
              {[{
            src: 'https://cdn.magicpatterns.com/uploads/oBvAZtqzPuy7HXhDyjVwCK/монстр_1.svg',
            name: 'Гримрак',
            color: '#7C4DFF'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/jZiruc2coCdxTuUVHLfsi2/content_60a30ee9-16df-41f1-9c0f-90f90e440018-2.svg',
            name: 'Сталеарх',
            color: '#E91E63'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/rEFCDGHMZdBnp11GKMfrt5/content_5f604f69-5911-4d38-acdf-fc59ffa9447f-2.svg',
            name: 'Златохват',
            color: '#F59E0B'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/wQPWQKaDmAhtMozvA5NNHi/content_19e2a54f-5361-46b5-b702-555ecd730fd5-2.svg',
            name: 'Шуморяд',
            color: '#00BCD4'
          }].map((monster, i) => <div key={i} className="flex flex-col items-center gap-1" data-id="element-974" data-mp="3m6pa9byrq8nu" data-mpi={i}>
                  <div className="relative" data-id="element-975" data-mp="1pd40dpsqs307">
                    <img src={monster.src} alt={monster.name} style={{
                width: 44,
                height: 44,
                objectFit: 'contain',
                filter: 'grayscale(0.85) opacity(0.45)'
              }} data-id="element-976" data-mp="1pcu7nugbbhqt" />
                    <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-green-500 flex items-center justify-center border-2 border-white shadow-sm" data-id="element-977" data-mp="21nbnqbyrknpc">
                      <Check size={9} color="white" strokeWidth={3} data-id="element-978" data-mp="26oiwoecn7sxl" />
                    </div>
                  </div>
                  <span className="text-[9px] font-bold" style={{
              color: '#B8A880'
            }} data-id="element-979" data-mp="1dxr2fmf51ecw">
                    {monster.name}
                  </span>
                </div>)}
            </div>

            {/* Stats row */}
            <div className="flex items-center justify-center gap-4 mb-7" data-id="element-980" data-mp="2ubha135gukra">
              {[{
            label: 'Хаос',
            value: '0%',
            color: '#16A34A',
            icon: '✓'
          }, {
            label: 'Энергия',
            value: '100%',
            color: '#7C4DFF',
            icon: '💎'
          }, {
            label: 'Прогресс',
            value: '100%',
            color: '#C4A040',
            icon: '🏆'
          }].map((stat, i) => <div key={i} className="flex flex-col items-center px-3 py-2 rounded-2xl" style={{
            background: 'rgba(255,255,255,0.65)',
            border: '1px solid rgba(139,105,20,0.18)',
            backdropFilter: 'blur(8px)'
          }} data-id="element-981" data-mp="uzfizpg6qevk" data-mpi={i}>
                  <span className="text-base leading-none mb-0.5" data-id="element-982" data-mp="1dt1mja8zn4gk">
                    {stat.icon}
                  </span>
                  <span className="text-xs font-bold" style={{
              color: stat.color
            }} data-id="element-983" data-mp="18r2h7utotxgz">
                    {stat.value}
                  </span>
                  <span className="text-[9px] font-semibold uppercase tracking-wide" style={{
              color: '#8B6914'
            }} data-id="element-984" data-mp="1ihas71ctvu9r">
                    {stat.label}
                  </span>
                </div>)}
            </div>

            {/* Divider */}
            <div className="flex items-center gap-3 mb-6 px-4" data-id="element-985" data-mp="1ehaejixjzn3r">
              <div className="flex-1 h-px" style={{
            background: 'rgba(139,105,20,0.18)'
          }} data-id="element-986" data-mp="zrmawb1wgccv" />
              <span className="text-sm" style={{
            color: '#C4A040'
          }} data-id="element-987" data-mp="qp3d45cz0pxh">
                ✦
              </span>
              <div className="flex-1 h-px" style={{
            background: 'rgba(139,105,20,0.18)'
          }} data-id="element-988" data-mp="2xdlv5gm9qz0b" />
            </div>

            {/* Transition headline */}
            <h2 className="text-2xl sm:text-3xl font-bold leading-tight mb-3" style={{
          color: '#3D2800'
        }} data-id="element-989" data-mp="2nou3zap18iqg">
              Все 4 монстра повержены.
              <br data-id="element-990" data-mp="3gbye1u2zfn93" />
              Ваш детский сад свободен.
            </h2>
            <p className="text-base font-medium leading-relaxed mb-8" style={{
          color: '#8B6914'
        }} data-id="element-991" data-mp="3bey7zj64ukhz">
              Гримрак, Сталеарх, Златохват и Шуморяд больше не крадут ваше
              время, деньги и нервы. Теперь — только{' '}
              <span className="text-[#7C4DFF] font-semibold" data-id="element-992" data-mp="1v06dn0pff361">дети</span>.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6" data-id="element-993" data-mp="1qwi4wep261j7">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold text-base transition-all active:scale-95 w-full sm:w-auto" style={{
            background: 'linear-gradient(135deg, #FFD700 0%, #E8A800 100%)',
            color: '#3D1A00',
            boxShadow: '0 0 28px rgba(200,160,0,0.45), 0 4px 16px rgba(0,0,0,0.10)',
            textDecoration: 'none'
          }} data-id="element-994" data-mp="6hbwk2bja5h5">
                🚀 Получить демо Meelo
              </a>
              <button onClick={() => {
            setShowCompletionOverlay(false);
            sessionStorage.setItem('scrollTo', 'solutions');
            setTimeout(() => {
              window.location.href = '/';
            }, 100);
          }} className="inline-flex items-center justify-center px-7 py-4 rounded-full font-medium text-base transition-all active:scale-95 w-full sm:w-auto" style={{
            border: '2px solid rgba(139,105,20,0.32)',
            color: '#5D3A00',
            background: 'rgba(255,255,255,0.50)',
            backdropFilter: 'blur(8px)'
          }} data-id="element-995" data-mp="1358jdoxkdx0t">
                Посмотреть возможности
              </button>
            </div>

            {/* Dismiss hint */}
            <button onClick={() => setShowCompletionOverlay(false)} className="text-xs font-medium transition-opacity hover:opacity-70" style={{
          color: '#B8A880'
        }} data-id="element-996" data-mp="11ouqku5iolvr">
              Вернуться к карте ↩
            </button>
          </div>
        </div>}

      {/* ── MISSION MODAL ────────────────────────────────────────────── */}
      {activeMission !== null && activeBuilding && <div className="fixed inset-0 z-[100] flex items-end justify-center sm:items-center sm:p-4" data-id="element-997" data-mp="3q4nxnzva1tnf">
          <div className="absolute inset-0 bg-black/45 backdrop-blur-sm" onClick={() => setActiveMission(null)} data-id="element-998" data-mp="3uzjr94g5wp2n" />
          <div className="bg-white w-full max-w-2xl rounded-t-3xl sm:rounded-3xl max-h-[92vh] overflow-y-auto relative z-10 shadow-2xl" style={{
        animation: 'modal-slide-up 0.4s cubic-bezier(0.16,1,0.3,1) forwards'
      }} data-id="element-999" data-mp="3m06h09k7rwgv">
            <div className="relative px-6 pt-6 pb-5 rounded-t-3xl overflow-hidden" style={{
          background: activeBuilding.modalGradient
        }} data-id="element-1000" data-mp="3w4urfhi9b8q">
              <div className="flex items-start justify-between" data-id="element-1001" data-mp="wizay07ahoge">
                <div className="flex items-center gap-3" data-id="element-1002" data-mp="11ah1rvflm8nn">
                  <span className="text-3xl" data-id="element-1003" data-mp="11c1wpm5trtm1">{activeBuilding.icon}</span>
                  <div data-id="element-1004" data-mp="239ot9u71hbo7">
                    <p className="text-xs font-semibold text-white/60 uppercase tracking-widest mb-0.5" data-id="element-1005" data-mp="23ahp404gmgrk">
                      Миссия {activeMission}
                    </p>
                    <h3 className="font-bold text-white text-lg leading-tight" data-id="element-1006" data-mp="2d1m4v21ym5ng">
                      {activeBuilding.name}
                    </h3>
                  </div>
                </div>
                <button onClick={() => setActiveMission(null)} className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors mt-1" data-id="element-1007" data-mp="1kcxbxqb256ms">
                  <X size={16} color="white" data-id="element-1008" data-mp="1tb925r80i2ep" />
                </button>
              </div>
              <div className="mt-4 flex items-start gap-2.5" data-id="element-1009" data-mp="1yd80gmowa94s">
                <div className="w-7 h-7 rounded-full bg-white/20 overflow-hidden flex-shrink-0 mt-0.5" data-id="element-1010" data-mp="34sihq2o0saaq">
                  <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-1011" data-mp="39q0q9ry4kni7" />
                </div>
                <p className="text-sm text-white/85 leading-relaxed italic" data-id="element-1012" data-mp="3a4pbjr3i9bhj">
                  «{activeBuilding.quote}»
                </p>
              </div>
            </div>
            <div className="p-6" data-id="element-1013" data-mp="361j5okkb1mbl">
              {activeMission === 1 && <Mission1 onComplete={() => handleComplete(1)} data-id="element-1014" data-mp="315kbuhg7jc3s" />}
              {activeMission === 2 && <Mission2 onComplete={() => handleComplete(2)} data-id="element-1015" data-mp="2w7isdvevdars" />}
              {activeMission === 3 && <Mission3 onComplete={() => handleComplete(3)} data-id="element-1016" data-mp="2n4rii01n6n29" />}
              {activeMission === 4 && <Mission4 onComplete={() => handleComplete(4)} data-id="element-1017" data-mp="pdosxe9cwhxq" />}
            </div>
          </div>
        </div>}

      {/* ── FINAL SECTION ────────────────────────────────────────────── */}
      <section className="py-20 lg:py-28 relative overflow-hidden transition-all duration-1000" style={{
      display: allDone ? 'block' : 'none',
      background: 'linear-gradient(180deg, #FFF9F0 0%, #F8F5FF 50%, white 100%)'
    }} data-id="element-1018" data-mp="2ev267w9amtsm">
        <div className="max-w-xl mx-auto px-4 text-center relative z-10" data-id="element-1019" data-mp="29xskaql4509j">
          {allDone && <div className="inline-flex items-center gap-2 bg-[#F5F3FF] text-[#7C4DFF] text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-6 border border-[#DDD6FE]" data-id="element-1020" data-mp="2xnehj8hxd5ew">
              ✨ Представьте ваш сад с Meelo
            </div>}
          <div className="w-24 h-24 mx-auto rounded-full bg-[#EDE7F6] border-4 border-[#7C4DFF]/15 overflow-hidden mb-6 shadow-lg" style={{
          animation: 'meelo-bounce 2s ease-in-out infinite',
          boxShadow: allDone ? '0 0 0 8px rgba(124,77,255,0.08), 0 0 0 16px rgba(124,77,255,0.04)' : 'none'
        }} data-id="element-1021" data-mp="2tkq7ixhh5sgc">
            <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-2" data-id="element-1022" data-mp="15mz6n9yeoe2g" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A2E] mb-3 leading-tight" data-id="element-1023" data-mp="1eop0emfrfp3e">
            Как изменится ваш сад
            <br data-id="element-1024" data-mp="qyciqjupqdzm" />
            <span className="text-[#7C4DFF]" data-id="element-1025" data-mp="qvqbklbqi0hx">с Meelo</span>
          </h2>
          <p className="text-lg text-gray-500 mb-8 leading-relaxed" data-id="element-1026" data-mp="m0kt5whjj3yl">
            Автоматизация рутины, полный порядок в данных и спокойные вечера —{' '}
            <span className="text-[#7C4DFF] font-semibold" data-id="element-1027" data-mp="vwnrssd6okgs">
              уже через несколько дней
            </span>
            .
          </p>

          {/* Benefit cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 text-left" data-id="element-1028" data-mp="858ooxdl1z4h">
            {[{
            icon: '📊',
            title: 'Все данные в одном месте',
            desc: 'Оплаты, посещаемость, закупки — в одной панели. Никаких чатов и Excel.',
            color: '#7C4DFF',
            bg: '#F5F3FF',
            border: '#DDD6FE'
          }, {
            icon: '⚡',
            title: 'Документы за секунды',
            desc: 'Циклограммы, конспекты, меню — система генерирует автоматически.',
            color: '#E91E63',
            bg: '#FFF0F6',
            border: '#FECDD3'
          }, {
            icon: '💰',
            title: 'Деньги под контролем',
            desc: 'Точные закупки, автоматические списания, нулевые утечки бюджета.',
            color: '#D97706',
            bg: '#FFFBEB',
            border: '#FDE68A'
          }, {
            icon: '📱',
            title: 'Родители всегда в курсе',
            desc: 'Лента дня, меню, расписание — родители сами находят ответы.',
            color: '#0891B2',
            bg: '#ECFEFF',
            border: '#A5F3FC'
          }].map((item, i) => <div key={i} className="rounded-2xl px-4 py-3.5 flex items-start gap-3" style={{
            background: item.bg,
            border: `1.5px solid ${item.border}`,
            animation: `fadeInUp 400ms ${i * 80}ms ease both`
          }} data-id="element-1029" data-mp="1non4tzf67k2z" data-mpi={i}>
                <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-1030" data-mp="2bfshk5ptdw92">
                  {item.icon}
                </span>
                <div data-id="element-1031" data-mp="27f8mr8spr4q3">
                  <p className="text-sm font-bold leading-snug mb-0.5" style={{
                color: item.color
              }} data-id="element-1032" data-mp="22ekvcm0kolvc">
                    {item.title}
                  </p>
                  <p className="text-xs text-gray-500 font-medium leading-relaxed" data-id="element-1033" data-mp="qxumsw8ofhyk">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-1034" data-mp="xdbjv98vqvaj">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full bg-[#7C4DFF] text-white font-semibold text-lg hover:bg-[#651FFF] transition-all" style={{
            animation: allDone ? 'pulse-cta 2.5s ease infinite' : 'none',
            boxShadow: '0 4px 20px -2px rgba(124,77,255,0.35)'
          }} data-id="element-1035" data-mp="jfdbqll5jv3h">
              🚀 Хочу демо Meelo
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-full border-2 border-[#7C4DFF]/20 text-[#7C4DFF] font-medium text-lg hover:bg-[#7C4DFF]/5 transition-all" data-id="element-1036" data-mp="3mvtsjf3ik50j">
              Запустить систему
            </a>
          </div>
        </div>
      </section>

      {/* Toast */}
      <div style={{
      position: 'fixed',
      bottom: 24,
      left: '50%',
      transform: `translateX(-50%) translateY(${toastVisible ? 0 : 80}px)`,
      opacity: toastVisible ? 1 : 0,
      transition: 'all 300ms ease',
      pointerEvents: 'none',
      zIndex: 200
    }} data-id="element-1037" data-mp="3hb4c0b3u75zq">
        <div className="bg-[#1A1A2E] text-white text-sm font-medium px-5 py-3 rounded-2xl shadow-xl whitespace-nowrap" data-id="element-1038" data-mp="3m7la9y4r30qj">
          {toastMsg}
        </div>
      </div>
    </div>;
}